<template>
  <div class="content">
    <div class="container">
      <div v-if="loading">
        <div id="loader">
          <font-awesome-icon icon="spinner" spin />
        </div>
      </div>
    </div>

    <b-breadcrumb v-if="rol === 'Cliente'">
      <b-breadcrumb-item :to="{ name: 'ClientComparecientes' }">Comparecientes</b-breadcrumb-item>
      <b-breadcrumb-item active>Editar compareciente</b-breadcrumb-item>
    </b-breadcrumb>

    <b-breadcrumb v-if="rol === 'Staff' && corredurias_id === 1">
      <b-breadcrumb-item :to="{ name: 'StaffComparecientes' }">Comparecientes</b-breadcrumb-item>
      <b-breadcrumb-item active>Editar compareciente</b-breadcrumb-item>
    </b-breadcrumb>

    <b-modal no-close-on-backdrop centered ref="modal-confirm-dialog-dom" hide-footer id="modal-confirm-dialog-dom">
      <h4 class="text-center">¿Seguro que quiere eliminar el domicilio?</h4>
      <h5 class="text-center">Se eliminarán todos los datos.</h5>
      <b-button class="mt-3" variant="danger" @click="$bvModal.hide('modal-confirm-dialog-dom')">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="deleteDomicilio">OK</b-button>
    </b-modal>

    <b-modal no-close-on-backdrop centered ref="modal-confirm-dialog-tel" hide-footer id="modal-confirm-dialog-tel">
      <h4 class="text-center">¿Seguro que quiere eliminar el teléfono?</h4>
      <h5 class="text-center">Se eliminarán todos los datos.</h5>
      <b-button class="mt-3" variant="danger" @click="$bvModal.hide('modal-confirm-dialog-tel')">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="deleteTelefono">OK</b-button>
    </b-modal>

    <b-modal no-close-on-backdrop centered ref="modal-confirm-dialog-repre" hide-footer id="modal-confirm-dialog-repre">
      <h4 class="text-center">¿Seguro que quiere eliminar el representante?</h4>
      <h5 class="text-center">Se eliminarán todos los datos.</h5>
      <b-button class="mt-3" variant="danger" @click="$bvModal.hide('modal-confirm-dialog-repre')">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="deleteRepresentante">OK</b-button>
    </b-modal>

    <b-modal no-close-on-backdrop centered ref="modal-confirm-dialog-repre-dom" hide-footer id="modal-confirm-dialog-repre-dom">
      <h4 class="text-center">¿Seguro que quiere eliminar el domicilio?</h4>
      <h5 class="text-center">Se eliminarán todos los datos.</h5>
      <b-button class="mt-3" variant="danger" @click="$bvModal.hide('modal-confirm-dialog-repre-dom')">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="deleteDomicilioRepresentante">OK</b-button>
    </b-modal>

    <b-modal no-close-on-backdrop centered ref="modal-confirm-dialog-repre-tel" hide-footer id="modal-confirm-dialog-repre-tel">
      <h4 class="text-center">¿Seguro que quiere eliminar el teléfono?</h4>
      <h5 class="text-center">Se eliminarán todos los datos.</h5>
      <b-button class="mt-3" variant="danger" @click="$bvModal.hide('modal-confirm-dialog-repre-tel')">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="deleteTelefonoRepresentante">OK</b-button>
    </b-modal>

    <b-modal no-close-on-backdrop centered ref="domicilio-modal" title="" hide-footer id="modalD" size="xl">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(postDomicilio)" @change="getAddressInMapCompar(null)">
          <ModalDomicilio :servicio="proceso" :currentDomicilio="currentDomicilio" @submit.prevent />
        </form>
      </ValidationObserver>
    </b-modal>

    <b-modal no-close-on-backdrop centered ref="telefono-modal" title="" hide-footer id="modalT" size="lg">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(postTelefono)">
          <ModalTelefono :currentTelefono="currentTelefono" @submit.prevent />
        </form>
      </ValidationObserver>
    </b-modal>

    <b-modal no-close-on-backdrop ref="representante-modal" title="" hide-footer size="xl" id="modalR">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(postRepresentante)">
          <ModalRepresentante
            :currentRepresentante="currentRepresentante"
            :servicio="proceso"
            @submit.prevent
            @state="mismaDataConstitutiva"
          />
        </form>
      </ValidationObserver>

      <b-card>
        <h4 class="cardD">
          Domicilio
          <b-button
            v-if="currentRepresentante.domicilios.length === 0"
            variant="success"
            class="btn-fill"
            size="sm"
            @click="addDomicilioRepresentante"
          >
            +
          </b-button>
        </h4>

        <b-table :fields="fieldsDomicilios" :items="currentRepresentante.domicilios" hover>
          <template #cell(index)="{ index }">
            {{ getIndex(index + 1) }}
          </template>
          <template #cell(mapUrl)="{ item }">
            <DrawGoogleMap
              @location="updateCoordinates"
              :lat="parseFloat(item.lat)"
              :lng="parseFloat(item.lng)"
              style="width: 300px"
            />
          </template>
          <template #cell(acciones)="{ item }">
            <b-button
              variant="warning"
              size="sm"
              v-b-tooltip.hover
              title="Editar"
              class="editBtn"
              @click="editDomicilioRepresentante(item)"
            >
              <b-icon-pencil />
            </b-button>
            <b-button
              variant="danger"
              @click="predeleteDomicilioRepresentante(item.id)"
              size="sm"
              v-b-tooltip.hover
              title="Eliminar"
            >
              <b-icon-trash />
            </b-button>
          </template>
        </b-table>
      </b-card>

      <b-card>
        <h4 class="cardD">
          Teléfonos
          <b-button variant="success" class="btn-fill" size="sm" @click="addTelefonoRepresentante">+</b-button>
        </h4>
        <b-table :fields="fieldsTelefonos" :items="currentRepresentante.telefonos" hover>
          <template #cell(index)="{ index }">
            {{ getIndex(index + 1) }}
          </template>
          <template #cell(acciones)="{ item }">
            <b-button
              variant="warning"
              size="sm"
              v-b-tooltip.hover
              title="Editar"
              class="editBtn"
              @click="editTelefonoRepresentante(item)"
            >
              <b-icon-pencil />
            </b-button>
            <b-button
              variant="danger"
              @click="predeleteTelefonoRepresentante(item.id)"
              size="sm"
              v-b-tooltip.hover
              title="Eliminar"
            >
              <b-icon-trash />
            </b-button>
          </template>
        </b-table>
      </b-card>
    </b-modal>

    <b-modal no-close-on-backdrop centered ref="domicilio-modal-representante" title="" hide-footer id="modalDR" size="xl">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(postDomicilioRepresentante)" @change="getAddressInMapRepre(null)">
          <ModalDomicilio :currentDomicilio="currentDomicilio" @submit.prevent />
        </form>
      </ValidationObserver>
    </b-modal>

    <b-modal no-close-on-backdrop centered ref="telefono-modal-representante" title="" hide-footer id="modalTR" size="lg">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(postTelefonoRepresentante)">
          <ModalTelefono :currentTelefono="currentTelefono" @submit.prevent />
        </form>
      </ValidationObserver>
    </b-modal>

    <b-modal no-close-on-backdrop centered ref="modal-confirm-dialog-documento" hide-footer id="modal-confirm-dialog-documento">
      <h4 class="text-center">¿Seguro que quiere eliminar el documento?</h4>
      <h5 class="text-center"></h5>
      <b-button class="mt-3" variant="danger" @click="$bvModal.hide('modal-confirm-dialog-documento')">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="deleteDocumento">OK</b-button>
    </b-modal>

    <b-modal no-close-on-backdrop centered ref="documento-modal" title="" hide-footer id="modalC" size="xl">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(postDocumento)">
          <ModalDocumentos
            :currentDocumento="currentDocumento"
            :options="optionsDocumentosComputed"
            :options-r-o="optionsDocumentosReadOnlyComputed"
            @submit.prevent
          />
        </form>
      </ValidationObserver>
    </b-modal>

    <b-modal no-close-on-backdrop centered ref="documento-modal-preview-img" title="" hide-footer id="modaldi" size="xl">
      <ModalPreviewImg :currentDocumento="currentDocumento" />
    </b-modal>

    <b-modal no-close-on-backdrop centered ref="documento-modal-preview-pdf" title="" hide-footer id="modaldf" size="xl">
      <ModalPreviewPDF :currentDocumento="currentDocumento" />
    </b-modal>

    <div class="container">
      <b-card>
        <b-card-text class="orange-text f13">Compareciente del cliente: {{ compareciente.cliente }}</b-card-text>
      </b-card>

      <b-card class="card">
        <div v-if="![3].includes(proceso)">
          <div class="row">
            <div class="col-md-6">
              <ValidationProvider
                name="persona"
                rules="required"
                v-slot="{ errors }"
                :custom-messages="{ required: 'La persona es obligatoria' }"
              >
                <label for="">Persona</label>
                <select
                  v-model="compareciente.persona"
                  class="custom-select"
                  :disabled="compareciente.disabled || compareciente.es_beneficiario"
                >
                  <option value="Física">Física</option>
                  <option value="Moral">Moral</option>
                  <option value="Fideicomiso">Fideicomiso</option>
                </select>
                <span class="cardErrors">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <br />
        </div>

        <h4 class="cardD" v-if="compareciente.persona === 'Fideicomiso'">Datos de identificación del Fiduciario</h4>
        <h4 class="cardD" v-else>Datos de identificación</h4>

        <div v-if="compareciente.persona === 'Física'">
          <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(editCompareciente)">
              <FormFisica :user="compareciente" :ratificacion="ratificacion" :servicio="proceso" @submit.prevent />
            </form>
          </ValidationObserver>
        </div>

        <div v-if="compareciente.persona === 'Moral'">
          <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(editCompareciente)">
              <FormMoral :user="compareciente" :ratificacion="ratificacion" @submit.prevent />
            </form>
          </ValidationObserver>
        </div>

        <div v-if="compareciente.persona === 'Fideicomiso'">
          <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(editCompareciente)">
              <FormFideicomiso :user="compareciente" @submit.prevent />
            </form>
          </ValidationObserver>
        </div>
      </b-card>

      <b-card>
        <h4 class="cardD">
          Domicilio
          <b-button
            variant="success"
            class="btn-fill"
            size="sm"
            v-if="addDomicilioBtn"
            :disabled="compareciente.disabled"
            @click="addDomicilio"
          >
            +
          </b-button>
        </h4>
        <div v-if="proceso == 4">
          <p class="cardErrors mb-2">Registrar domicilio de contacto para este asunto particular</p>
        </div>
        <div v-else>
          <p class="cardErrors mb-2" v-if="compareciente.persona === 'Física' || compareciente.persona === 'Moral'">
            Es nesario registrar un domicilio particular y uno fiscal.
          </p>
        </div>

        <b-table :fields="fieldsDomicilios" :items="compareciente.domicilios" hover>
          <template #cell(index)="{ index }">
            {{ getIndex(index + 1) }}
          </template>

          <template #cell(mapUrl)="{ item }">
            <DrawGoogleMap
              @location="updateCoordinates"
              :lat="parseFloat(item.lat)"
              :lng="parseFloat(item.lng)"
              style="width: 300px"
            />
          </template>

          <template #cell(acciones)="{ item }">
            <b-button
              variant="warning"
              size="sm"
              v-b-tooltip.hover
              title="Editar"
              class="editBtn"
              @click="editDomicilio(item)"
              :disabled="compareciente.disabled"
            >
              <b-icon-pencil />
            </b-button>
            <b-button
              variant="danger"
              @click="predeleteDomicilio(item.id)"
              :disabled="compareciente.disabled"
              size="sm"
              v-b-tooltip.hover
              title="Eliminar"
            >
              <b-icon-trash />
            </b-button>
          </template>
        </b-table>
      </b-card>

      <b-card v-if="!compareciente.es_beneficiario">
        <h4 class="cardD">Datos de contacto</h4>
        <span class="cardErrors mb-2" v-if="proceso == 4">
          Registrar un correo electrónico y un teléfono celular de contacto para este asunto particular
        </span>
        <span class="cardErrors mb-2" v-else>
          Favor de ingresar un correo electrónico válido así como un número telefónico de celular ya que serán necesarios para el
          proceso de Firma Digital.
        </span>

        <div>
          <ValidationProvider
            name="email"
            rules="required|email"
            v-slot="{ errors }"
            :custom-messages="{
              required: 'El email es obligatorio',
              email: 'Debe ser un email válido',
            }"
          >
            <base-input
              :disabled="compareciente.disabled"
              type="email"
              label="Email"
              placeholder="Email"
              v-model="compareciente.email"
            ></base-input>
            <span class="cardErrors">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>

        <h4 class="cardD">
          Teléfonos
          <b-button variant="success" class="btn-fill" size="sm" @click="addTelefono" :disabled="compareciente.disabled">
            +
          </b-button>
        </h4>
        <b-table :fields="fieldsTelefonos" :items="compareciente.telefonos" hover>
          <template #cell(index)="{ index }">
            {{ getIndex(index + 1) }}
          </template>
          <template #cell(acciones)="{ item }">
            <b-button
              variant="warning"
              size="sm"
              v-b-tooltip.hover
              title="Editar"
              class="editBtn"
              @click="editTelefono(item)"
              :disabled="compareciente.disabled"
            >
              <b-icon-pencil />
            </b-button>
            <b-button
              variant="danger"
              @click="predeleteTelefono(item.id)"
              :disabled="compareciente.disabled"
              size="sm"
              v-b-tooltip.hover
              title="Eliminar"
            >
              <b-icon-trash />
            </b-button>
          </template>
        </b-table>
      </b-card>

      <b-card>
        <div v-if="compareciente.persona === 'Física'">
          <b-form-group
            id="input-group-actua-derecho-propio"
            label="Actúa por derecho propio:"
            label-for="input-actua-derecho-propio"
          >
            <b-form-checkbox
              id="input-actua-derecho-propio"
              v-model="compareciente.actua_derecho_propio"
              :disabled="compareciente.disabled || compareciente.es_beneficiario"
            ></b-form-checkbox>
          </b-form-group>
        </div>

        <div v-if="!compareciente.actua_derecho_propio">
          <h4 class="cardD">
            Apoderados o Representantes Legales
            <b-button variant="success" class="btn-fill" size="sm" @click="addRepresentante" :disabled="compareciente.disabled">
              +
            </b-button>
          </h4>
          <div class="text-center">
            <b-table :fields="fields" :items="representantes" hover>
              <template #cell(index)="{ index }">
                {{ getIndex(index + 1) }}
              </template>
              <template #cell(acciones)="{ item }">
                <b-button
                  variant="warning"
                  size="sm"
                  v-b-tooltip.hover
                  title="Editar"
                  class="editBtn"
                  @click="editRepresentante(item)"
                  :disabled="compareciente.disabled"
                >
                  <b-icon-pencil />
                </b-button>
                <b-button
                  variant="danger"
                  @click="predeleteRepresentantes(item.id)"
                  size="sm"
                  v-b-tooltip.hover
                  title="Eliminar"
                  :disabled="compareciente.disabled"
                >
                  <b-icon-trash />
                </b-button>
              </template>
            </b-table>
          </div>
        </div>
      </b-card>

      <b-card v-if="proceso !== 4">
        <div v-if="compareciente.persona === 'Física'">
          <h4 class="cardD">
            Documentos
            <b-button variant="success" class="btn-fill" size="sm" @click="addDocumento" :disabled="compareciente.disabled">
              +
            </b-button>
          </h4>
        </div>
        <div v-else>
          <h4 class="cardD">
            Documentos
            <b-button variant="success" class="btn-fill" size="sm" @click="addDocumento" :disabled="compareciente.disabled">
              +
            </b-button>
          </h4>
        </div>
        <b-table hover :fields="fieldsDocus" :items="compareciente.documentos">
          <template #cell(tipo)="{ item }">
            <div v-if="item.tipo === 'Otro'">
              <div v-b-tooltip.hover :title="item.descripcion">
                {{ item.tipo }}
              </div>
            </div>
            <div v-else>
              {{ item.tipo }}
            </div>
          </template>
          <template #cell(acciones)="{ item }">
            <b-button
              variant="warning"
              size="sm"
              v-b-tooltip.hover
              title="Editar"
              @click="editDocumento(item)"
              class="editBtn"
              :disabled="compareciente.disabled"
            >
              <b-icon-pencil />
            </b-button>
            <b-button
              variant="primary"
              size="sm"
              v-b-tooltip.hover
              title="Vista previa"
              @click="previewDocumento(item)"
              class="editBtn"
            >
              <b-icon-eye />
            </b-button>
            <b-button
              variant="danger"
              size="sm"
              v-b-tooltip.hover
              title="Eliminar"
              @click="predeleteDocumento(item.index)"
              class="editBtn"
              :disabled="compareciente.disabled"
            >
              <b-icon-trash />
            </b-button>
          </template>
        </b-table>
      </b-card>

      <b-card v-if="proceso !== 4 && compareciente.persona === 'Física'">
        <h4 class="cardD">Redes Sociales</h4>
        <RedesSociales :user="compareciente" />
      </b-card>

      <b-row>
        <b-col class="d-flex justify-content-end">
          <b-button class="btn-fill bottomLeft" size="lg" @click="regresarHandler">Regresar</b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import FormFideicomiso from "@/views/clients/comparecientes/FormFideicomiso.vue";
import FormFisica from "@/views/clients/comparecientes/FormFisica.vue";
import FormMoral from "@/views/clients/comparecientes/FormMoral.vue";
import ModalDomicilio from "@/views/clients/comparecientes/ModalDomicilio.vue";
import RedesSociales from "@/views/clients/comparecientes/RedesSociales.vue";
import {
  CambiosConstitutivaApi,
  CatDocumentosApi,
  CatNacionalidadesApi,
  ClientesApi,
  ComparecientesApi,
  FuncionesApi,
  CatFormulariosConstitucionSociedadesApi,
} from "@/api";
import Storage from "@/utils/storage";
import DrawGoogleMap from "@/views/clients/comparecientes/DrawGoogleMap.vue";
import ModalRepresentante from "@/views/clients/comparecientes/ModalRepresentante.vue";
import ModalTelefono from "@/views/clients/comparecientes/ModalTelefono.vue";
import ModalDocumentos from "@/views/clients/procesos/constitucion/entregadocumentos/ModalDocumentos.vue";
import ModalPreviewImg from "@/views/clients/procesos/constitucion/entregadocumentos/ModalPreviewImg.vue";
import ModalPreviewPDF from "@/views/clients/procesos/constitucion/entregadocumentos/ModalPreviewPDF.vue";

import { ref, getCurrentInstance, onMounted, computed } from "vue";

import { useComparecientesStore } from "@/stores";
import { tryParseInt } from "@/utils/number-utils";

const storage = new Storage();

import { getGoogleMapUrl } from "@/utils/google-maps-utils";

export default {
  name: "EditCompareciente",

  components: {
    FormFisica,
    FormMoral,
    ModalDomicilio,
    ModalTelefono,
    ModalRepresentante,
    FormFideicomiso,
    RedesSociales,
    DrawGoogleMap,
    ModalDocumentos,
    ModalPreviewImg,
    ModalPreviewPDF,
  },

  computed: {
    fields() {
      return [
        { key: "index", label: "", class: "text-center" },
        // { key: "representante", label: "Representante", class: "text-center" },
        { key: "nombre", label: "Nombre", class: "text-center" },
        { key: "paterno", label: "Paterno", class: "text-center" },
        { key: "materno", label: "Materno", class: "text-center" },
        { key: "email", label: "Email", class: "text-center" },
        { key: "rfc", label: "RFC", class: "text-center" },
        { key: "acciones", label: "Acciones", class: "text-center" },
      ];
    },
    fieldsDomicilios() {
      return [
        { key: "index", label: "", class: "text-center" },
        { key: "tipo", label: "Tipo", class: "text-center" },
        { key: "calle", label: "Calle", class: "text-center" },
        { key: "num_exterior", label: "Número", class: "text-center" },
        { key: "colonia", label: "Colonia", class: "text-center" },
        { key: "entidad", label: "Entidad", class: "text-center" },
        { key: "pais", label: "País", class: "text-center" },
        { key: "mapUrl", label: "Mapa", class: "text-center" },
        { key: "acciones", label: "Acciones", class: "text-center" },
      ];
    },
    fieldsTelefonos() {
      return [
        { key: "index", label: "", class: "text-center" },
        { key: "tipo", label: "Tipo", class: "text-center" },
        { key: "clave", label: "Clave", class: "text-center" },
        { key: "numero", label: "Número", class: "text-center" },
        // { key: "extension", label: "Extension", class: "text-center" },
        { key: "acciones", label: "Acciones", class: "text-center" },
      ];
    },
    fieldsDocus() {
      return [
        // { key: "index", label: "", class: "text-center" },
        { key: "nombreFile", label: "Nombre", class: "text-center" },
        { key: "tipo", label: "Tipo", class: "text-center" },
        // { key: "nombre", label: "Persona Física", class: "text-center" },
        { key: "acciones", label: "Acciones", class: "text-center" },
      ];
    },
    optionsDocumentosComputed() {
      let arr = [];

      if (this.compareciente.persona === "Física") {
        if (this.compareciente.actua_derecho_propio) {
          arr = this.optionsFisicas;
        } else {
          arr = this.optionsFisicasRepresentadas;
        }
      } else if (this.compareciente.persona === "Moral") {
        arr = this.optionsMorales;
      } else if (this.compareciente.persona === "Fideicomiso") {
        arr = this.optionsFideicomisos;
      }

      if (this.compareciente.documentos.length > 0) {
        arr = arr.filter((d) => !this.compareciente.documentos.some((doc) => doc.cat_documentos_id == d.value));
      }

      if (this.compareciente.actua_derecho_propio) {
        arr = arr.filter((d) => parseInt(d.value) != 97);
      }

      if (this.proceso === 1) {
        if (this.compareciente.actua_derecho_propio) {
          arr = arr.filter((d) => ![97, 100, 102, 103].includes(d.value));
        }
      }

      arr = this.filterRequiredCatDocumentosByProceso(arr);

      return arr;
    },
    optionsDocumentosReadOnlyComputed() {
      let arr = [];

      if (this.compareciente.persona === "Física") {
        if (this.compareciente.actua_derecho_propio) {
          arr = structuredClone(this.optionsFisicas);
        } else {
          arr = structuredClone(this.optionsFisicasRepresentadas);
        }
      } else if (this.compareciente.persona === "Morales") {
        arr = structuredClone(this.optionsMorales);
      } else if (this.compareciente.persona === "Fideicomiso") {
        arr = structuredClone(this.optionsFideicomisos);
      }

      return arr;
    },
    optionsDocumentosFisica() {
      let arr = [...this.optionsFisicas];

      if (this.compareciente.documentos.length > 0) {
        arr = arr.filter((d) => !this.compareciente.documentos.some((doc) => doc.cat_documentos_id == d.value));
      }

      if (this.compareciente.actua_derecho_propio) {
        arr = arr.filter((d) => parseInt(d.value) != 97);
      }

      arr = this.filterRequiredCatDocumentosByProceso(arr);

      return arr;
    },
    optionsDocumentosMorales() {
      let arr = [...this.optionsMorales];

      arr = this.filterRequiredCatDocumentosByProceso(arr);

      if (this.compareciente.documentos.length > 0) {
        arr = arr.filter((d) => !this.compareciente.documentos.some((doc) => doc.cat_documentos_id == d.value));
      }

      return arr;
    },
  },

  watch: {
    "currentDomicilio.pais": "changePais",
    "currentDomicilio.tipo": "tipoDomicilio",
  },

  setup() {
    const { proxy } = getCurrentInstance();
    const vm = proxy;
    const router = vm.$router;
    const route = vm.$route;

    const comparecientesStore = useComparecientesStore();
    const comparecienteId = ref(tryParseInt(route.params.id));

    if (!comparecienteId.value) {
      router.push({ name: "NotFound" });
      return;
    }

    const ratificacion = ref(route.params.ratificacion);
    const proceso = ref(Number(route.query.proceso));
    const procesoId = ref(Number(route.query.procesoId));

    if (comparecientesStore.comparecientes.length === 0) {
      comparecientesStore.addCompareciente();
    }

    onMounted(async () => {
      try {
        await vm.getCatDocumentosPF();
        await vm.getCatDocumentosPFR();
        await vm.getCatDocumentosPM();
        await vm.getCatDocumentosF();
        await vm.getCatNacionalidades();

        const indexComparecienteCargado = comparecientesStore.comparecientes.findIndex((c) => c.id === comparecienteId.value);

        if (indexComparecienteCargado !== -1) {
          comparecientesStore.selectCompareciente(indexComparecienteCargado);

          const result = await ComparecientesApi.checkComparecienteSyncStatus(comparecientesStore.currentCompareciente.id, {
            actualizado: comparecientesStore.currentCompareciente.actualizado,
          });

          if (!result.isUpToDate) {
            await vm.getCompareciente();
          }
        } else {
          const indexComparecienteVacio = comparecientesStore.comparecientes.findIndex((c) => !c.id);

          if (indexComparecienteVacio !== -1) {
            comparecientesStore.selectCompareciente(indexComparecienteVacio);
          } else {
            comparecientesStore.addCompareciente();
            comparecientesStore.selectCompareciente(comparecientesStore.comparecientes.length - 1);
          }

          await vm.getCompareciente();
        }
      } catch (error) {
        console.error("Error loading data:", error);
      }
    });

    const compareciente = computed(() => comparecientesStore.currentCompareciente);
    const representantes = computed(() => compareciente.value?.representantes || []);

    return {
      comparecientesStore,
      compareciente,
      representantes,
      ratificacion,
      proceso,
      procesoId,
      comparecienteId,
    };
  },

  data: () => ({
    addDomicilioBtn: true,
    id: 0,
    loading: false,
    rol: null,
    corredurias_id: null,

    optionsCatDocumentosReadOnly: [],
    optionsFisicas: [],
    optionsFisicasRepresentadas: [],
    optionsMorales: [],
    optionsFideicomisos: [],

    currentDocumento: null,
    currentDocumentoId: null,

    domicilio: { mapUrl: null },
    telefono: {},
    representante: {},

    cat_nacionalidades: [],

    currentDomicilio: {
      tieneExtranjero: true,
      tieneTipo: true,
      compareciente: true,
      extranjero: null,
      mapUrl: null,
    },

    currentTelefono: {},
    currentRepresentante: {
      domicilios: [],
      telefonos: [],
      instrumento_numero: null,
      instrumento_numero_fecha: null,
      instrumento_fedatario: null,
      instrumento_fedatario_nombre: null,
      instrumento_fedatario_numero: null,
      instrumento_fedatario_estado: null,
      instrumento_rpf_folio: null,
      instrumento_rpf_folio_fecha: null,
      instrumento_rpf_folio_lugar: null,
    },

    currentPage: 1,
    perPage: 10,
    current_representantes_id: null,

    currentDomicilioId: null,
    currentTelefonoId: null,
    currentRepresentanteId: null,
    currentRepresentanteDomicilioId: null,
    currentRepresentanteTelefonoId: null,

    compareciente_original: {},
    cambios: [],
    domicilios_originales: [],
    telefonos_originales: [],
    representantes_originales: [],
    documentos_originales: [],
  }),

  methods: {
    async getCatDocumentosPF() {
      try {
        let categoria = "compareciente_pf";
        let tipo = null;

        if (this.proceso === 2) {
          categoria = "notificaciones";
          tipo = "pf";
        }

        const { value } = await CatDocumentosApi.list({
          page: 0,
          registersPerPage: 0,
          categoria: categoria,
          tipo: tipo,
        });

        this.optionsFisicas = value.map((d) => ({
          text: d.documento,
          value: d.id,
          obligatorio: d.obligatorio,
        }));
      } catch (error) {
        console.log(error);
        // this.loading = false;
      }
    },

    async getCatDocumentosPFR() {
      try {
        let categoria = "compareciente_pf";
        let tipo = null;

        if (this.proceso === 2) {
          categoria = "notificaciones";
          tipo = "pfr";
        }

        const { value } = await CatDocumentosApi.list({
          page: 0,
          registersPerPage: 0,
          categoria: categoria,
          tipo: tipo,
        });

        this.optionsFisicasRepresentadas = value.map((d) => ({
          text: d.documento,
          value: d.id,
          obligatorio: d.obligatorio,
        }));
      } catch (error) {
        console.log(error);
        // this.loading = false;
      }
    },

    async getCatDocumentosPM() {
      try {
        let categoria = "compareciente_pm";
        let tipo = null;

        if (this.proceso === 2) {
          categoria = "notificaciones";
          tipo = "pm";
        }

        const { value } = await CatDocumentosApi.list({
          page: 0,
          registersPerPage: 0,
          categoria: categoria,
          tipo: tipo,
        });

        this.optionsMorales = value.map((d) => ({
          text: d.documento,
          value: d.id,
          obligatorio: d.obligatorio,
        }));
      } catch (error) {
        // this.loading = false;
      }
    },

    async getCatDocumentosF() {
      try {
        let categoria = "compareciente_fideicomiso";
        let tipo = null;

        if (this.proceso === 2) {
          categoria = "notificaciones";
          tipo = "f";
        }

        const { value } = await CatDocumentosApi.list({
          page: 0,
          registersPerPage: 0,
          categoria: categoria,
          tipo: tipo,
        });

        this.optionsFideicomisos = value.map((d) => ({
          text: d.documento,
          value: d.id,
          obligatorio: d.obligatorio,
        }));
      } catch (error) {
        // this.loading = false;
      }
    },

    filterRequiredCatDocumentosByProceso(arr = []) {
      const arr_ = [];

      if (this.proceso === 1) {
        arr.forEach((d) => {
          let text = d.text;

          if (![16, 26, 27].includes(d.value)) {
            // #27 esta de sobra, quitar luego
            text += " (Obligatorio)";
            d.obligatorio = true;
          }

          arr_.push({
            text: text,
            value: d.value,
          });
        });
      } else if (this.proceso === 2) {
        arr.forEach((d) => {
          let text = d.text;

          if (d.obligatorio) {
            text += " (Obligatorio)";
          }

          arr_.push({
            text: text,
            value: d.value,
          });
        });
      } else {
        arr.forEach((d) => {
          arr_.push({
            text: d.text,
            value: d.value,
          });
        });
      }

      return arr_;
    },

    async getAddressInMapCompar(direcciones_id) {
      if (direcciones_id != null) {
        const index = this.compareciente.domicilios.findIndex((o) => o.id === direcciones_id);
        const address = `${this.compareciente.domicilios[index].calle},${this.compareciente.domicilios[index].num_exterior},${this.compareciente.domicilios[index].colonia},
          ${this.compareciente.domicilios[index].delegacion_municipio},${this.compareciente.domicilios[index].codigo_postal},
          ${this.compareciente.domicilios[index].ciudad},${this.compareciente.domicilios[index].entidad}`;
        const mapUrl = await getGoogleMapUrl(address);
        this.compareciente.domicilios[index].lat = mapUrl.lat;
        this.compareciente.domicilios[index].lng = mapUrl.lng;
      } else if (direcciones_id === null) {
        const address = `${this.currentDomicilio.calle},${this.currentDomicilio.num_exterior},${this.currentDomicilio.colonia},
          ${this.currentDomicilio.delegacion_municipio},${this.currentDomicilio.codigo_postal},${this.currentDomicilio.ciudad},
          ${this.currentDomicilio.entidad}`;
        const mapUrl = await getGoogleMapUrl(address);
        // console.log(mapUrl.lat);
        // this.currentDomicilio.mapUrl = mapUrl;
        this.currentDomicilio.lat = mapUrl.lat.toString(); //parseFloat(mapUrl.lat);
        this.currentDomicilio.lng = mapUrl.lng.toString(); //parseFloat(mapUrl.lng);
        const a = Object.assign({}, this.currentDomicilio);
        this.currentDomicilio = a;
      }
    },

    async getAddressInMapRepre(direcciones_id) {
      if (direcciones_id != null) {
        const index = this.currentRepresentante.domicilios.findIndex((o) => o.id === direcciones_id);
        const address = `${this.currentRepresentante.domicilios[index].calle},${this.currentRepresentante.domicilios[index].num_exterior},
          ${this.currentRepresentante.domicilios[index].colonia},
          ${this.currentRepresentante.domicilios[index].delegacion_municipio},
          ${this.currentRepresentante.domicilios[index].codigo_postal},${this.currentRepresentante.domicilios[index].ciudad},
          ${this.currentRepresentante.domicilios[index].entidad}`;

        const mapUrl = await getGoogleMapUrl(address);
        // this.currentRepresentante.domicilios[index].mapUrl = mapUrl;
        this.currentRepresentante.domicilios[index].lat = mapUrl.lat;
        this.currentRepresentante.domicilios[index].lng = mapUrl.lng;
      } else if (direcciones_id === null) {
        const address = `${this.currentDomicilio.calle},${this.currentDomicilio.num_exterior},${this.currentDomicilio.colonia},
          ${this.currentDomicilio.delegacion_municipio},${this.currentDomicilio.codigo_postal},${this.currentDomicilio.ciudad},
          ${this.currentDomicilio.entidad}`;
        const mapUrl = await getGoogleMapUrl(address);

        // this.currentDomicilio.mapUrl = mapUrl;
        this.currentDomicilio.lat = mapUrl.lat.toString();
        this.currentDomicilio.lng = mapUrl.lng.toString();
        const a = Object.assign({}, this.currentDomicilio);
        this.currentDomicilio = a;
      }
    },

    updateCoordinates(coordinates) {
      // console.log("updateCoordEditCompar");
      // console.log(coordinates.lat);
      // console.log(coordinates.lng);
      // this.currentDomicilio.lat=coordinates.lat;
      // this.currentDomicilio.lng=coordinates.lng;
      //acá no se hace nada porque está fuera de modal donde se save all
    },

    getIndex(index) {
      return index + (this.currentPage - 1) * this.perPage;
    },

    async getCompareciente() {
      try {
        this.loading = true;

        this.corredurias_id = storage.getItem("corredurias_id");

        const rol = storage.getItem("role");

        if (rol === "Cliente Administrador" || rol === "Cliente Usuario") {
          this.rol = "Cliente";
        } else {
          this.rol = "Staff";
        }

        const {
          creado,
          actualizado,
          activo,
          cliente_id,
          nombre,
          paterno,
          materno,
          email,
          persona,
          rfc,

          fecha_nacimiento,
          lugar_nacim_ciudad,
          lugar_nacim_estado,
          lugar_nacim_pais,
          curp,
          ocupacion,
          giro_negocios,
          alias,
          sexo,
          pais_residencia,
          estado_civil,
          identificacion_conyuge,
          regimen_patrimonial,
          identificacion_tipo,
          identificacion_autoridad,
          identificacion_numero,

          denominacion_social,
          fecha_constitucion,
          actividad,
          giro,
          objeto_social,
          domicilio_social,

          instrumento_numero,
          instrumento_numero_fecha,
          instrumento_fedatario,
          instrumento_fedatario_nombre,
          instrumento_fedatario_numero,
          instrumento_fedatario_estado,
          instrumento_rpf_folio,
          instrumento_rpf_folio_fecha,
          instrumento_rpf_folio_lugar,

          entidad_extranjera,
          datos_prueba_constitucion,
          facebook,
          twitter,
          instagram,
          linkedin,

          estatus_migratorio,
          fecha_ingreso_pais,

          domicilios,
          telefonos,
          representantes,
          nacionalidades,
          documentos,

          fiduciario,
          nombre_fideicomiso,
          fideicomitente,
          tipo_fideicomiso,
          fecha_creacion_fideicomiso,
          folio_inscripcion,
          rfc_fideicomiso,
          email_fideicomiso,
          tel_fideicomiso,

          completado,
          cat_servicio_id,
          servicio_id,
          tipo_poder,
          limitaciones_poder,
          vigencia_poder,
          actua_derecho_propio,
          es_beneficiario,
        } = await ComparecientesApi.detail(this.comparecienteId);

        if (activo && !completado) {
          this.compareciente.disabled = false;
        } else {
          this.compareciente.disabled = true;
        }

        //obtener el nombre del cliente al que "pertenecen"
        this.compareciente.id = this.comparecienteId;
        this.compareciente.creado = creado;
        this.compareciente.actualizado = actualizado;
        this.compareciente.activo = activo;
        this.compareciente.cliente = await this.getClienteName(cliente_id);
        this.compareciente.cliente_id = cliente_id;
        this.compareciente.nombre = nombre;
        this.compareciente.paterno = paterno;
        this.compareciente.materno = materno;
        this.compareciente.email = email;
        this.compareciente.persona = persona;
        this.compareciente.rfc = rfc;
        // this.compareciente.nacionalidad = nacionalidad;
        this.compareciente.facebook = facebook;
        this.compareciente.twitter = twitter;
        this.compareciente.instagram = instagram;
        this.compareciente.linkedin = linkedin;

        this.compareciente.tipo_poder = tipo_poder;
        this.compareciente.limitaciones_poder = limitaciones_poder;
        this.compareciente.vigencia_poder = vigencia_poder;
        this.compareciente.actua_derecho_propio = actua_derecho_propio;
        this.compareciente.es_beneficiario = es_beneficiario;

        if (es_beneficiario) {
          this.compareciente.persona = "Física";
        }

        this.compareciente.telefonos.splice(0, telefonos.length, ...telefonos);
        this.telefonos_originales = structuredClone(telefonos);

        if (domicilios.length !== 0) {
          this.addDomicilioBtn = false;

          for (let i = 0; i < domicilios.length; i++) {
            if (domicilios[i].extranjero) {
              domicilios[i].extranjero = true;
            } else if (!domicilios[i].extranjero) {
              domicilios[i].extranjero = false;
            }

            domicilios[i].tieneTipo = true;
            domicilios[i].tieneExtranjero = true;
          }
        }

        this.compareciente.domicilios = domicilios;
        this.domicilios_originales = structuredClone(domicilios);

        if (persona === "Física") {
          this.compareciente.fecha_nacimiento = fecha_nacimiento?.substring(0, 10) || "";
          this.compareciente.lugar_nacim_ciudad = lugar_nacim_ciudad;
          this.compareciente.lugar_nacim_estado = lugar_nacim_estado;
          this.compareciente.lugar_nacim_pais = lugar_nacim_pais;
          this.compareciente.curp = curp;
          this.compareciente.ocupacion = ocupacion;
          this.compareciente.giro_negocios = giro_negocios;
          this.compareciente.alias = alias;
          this.compareciente.sexo = sexo;
          this.compareciente.pais_residencia = pais_residencia;
          this.compareciente.estado_civil = estado_civil;
          this.compareciente.identificacion_conyuge = identificacion_conyuge;
          this.compareciente.regimen_patrimonial = regimen_patrimonial;
          this.compareciente.identificacion_numero = identificacion_numero;

          if (
            identificacion_tipo === "Credencial para votar" ||
            identificacion_tipo === "Pasaporte" ||
            identificacion_tipo === "Cédula Profesional" ||
            identificacion_tipo === "Licencia de Conducir" ||
            identificacion_tipo === "Forma Migratoria"
          ) {
            this.compareciente.identificacion_tipo = identificacion_tipo;
          } else {
            this.compareciente.identificacion_tipo = "Otro";
            this.compareciente.identificacion_tipo_otro = identificacion_tipo;
          }

          if (
            identificacion_autoridad === "Instituto Federal Electoral" ||
            identificacion_autoridad === "Instituto Nacional Electoral" ||
            identificacion_autoridad === "Secretaría de Relaciones Exteriores" ||
            identificacion_autoridad === "Secretaría de Educación Pública" ||
            identificacion_autoridad === "Instituto Nacional de Migración"
          ) {
            this.compareciente.identificacion_autoridad = identificacion_autoridad;
          } else {
            this.compareciente.identificacion_autoridad = "Otro";
            this.compareciente.identificacion_autoridad_otro = identificacion_autoridad;
          }

          this.compareciente.estatus_migratorio = estatus_migratorio;
          if (fecha_ingreso_pais != null) {
            this.compareciente.fecha_ingreso_pais = fecha_ingreso_pais?.substring(0, 10) || "";
          }
        } else if (persona === "Moral") {
          this.compareciente.denominacion_social = denominacion_social;
          this.compareciente.fecha_constitucion = fecha_constitucion?.substring(0, 10) || "";
          this.compareciente.actividad = actividad;
          this.compareciente.giro = giro;
          this.compareciente.objeto_social = objeto_social;
          this.compareciente.domicilio_social = domicilio_social;
          this.compareciente.instrumento_numero = instrumento_numero;
          this.compareciente.instrumento_numero_fecha = instrumento_numero_fecha?.substring(0, 10) || "";
          this.compareciente.instrumento_fedatario = instrumento_fedatario;
          this.compareciente.instrumento_fedatario_nombre = instrumento_fedatario_nombre;
          this.compareciente.instrumento_fedatario_numero = instrumento_fedatario_numero;
          this.compareciente.instrumento_fedatario_estado = instrumento_fedatario_estado;
          this.compareciente.instrumento_rpf_folio = instrumento_rpf_folio;
          this.compareciente.instrumento_rpf_folio_fecha = instrumento_rpf_folio_fecha?.substring(0, 10) || "";
          this.compareciente.instrumento_rpf_folio_lugar = instrumento_rpf_folio_lugar;

          if (entidad_extranjera === 1) {
            this.compareciente.entidad_extranjera = true;
          } else if (entidad_extranjera === 0) {
            this.compareciente.entidad_extranjera = false;
          }

          this.compareciente.datos_prueba_constitucion = datos_prueba_constitucion;
        } else if (persona === "Fideicomiso") {
          this.compareciente.denominacion_social = denominacion_social;
          this.compareciente.fecha_constitucion = fecha_constitucion?.substring(0, 10) || "";
          this.compareciente.actividad = actividad;
          this.compareciente.giro = giro;
          this.compareciente.objeto_social = objeto_social;
          this.compareciente.instrumento_numero = instrumento_numero;
          this.compareciente.instrumento_numero_fecha = instrumento_numero_fecha?.substring(0, 10) || "";
          this.compareciente.instrumento_fedatario = instrumento_fedatario;
          this.compareciente.instrumento_fedatario_nombre = instrumento_fedatario_nombre;
          this.compareciente.instrumento_fedatario_numero = instrumento_fedatario_numero;
          this.compareciente.instrumento_fedatario_estado = instrumento_fedatario_estado;
          this.compareciente.instrumento_rpf_folio = instrumento_rpf_folio;
          this.compareciente.instrumento_rpf_folio_fecha = instrumento_rpf_folio_fecha?.substring(0, 10) || "";
          this.compareciente.instrumento_rpf_folio_lugar = instrumento_rpf_folio_lugar;

          if (entidad_extranjera === 1) {
            this.compareciente.entidad_extranjera = true;
          } else if (entidad_extranjera === 0) {
            this.compareciente.entidad_extranjera = false;
          }

          this.compareciente.datos_prueba_constitucion = datos_prueba_constitucion;
          this.compareciente.fiduciario = fiduciario;
          this.compareciente.nombre_fideicomiso = nombre_fideicomiso;
          this.compareciente.fideicomitente = fideicomitente;

          // this.compareciente.tipo_fideicomiso = tipo_fideicomiso;
          if (
            tipo_fideicomiso === "Administración" ||
            tipo_fideicomiso === "Garantía" ||
            tipo_fideicomiso === "Fuente de Pago" ||
            tipo_fideicomiso === "Empresarial"
          ) {
            this.compareciente.tipo_fideicomiso = tipo_fideicomiso;
          } else {
            this.compareciente.tipo_fideicomiso = "Otro";
            this.compareciente.tipo_fideicomiso_otro = tipo_fideicomiso;
          }

          this.compareciente.fecha_creacion_fideicomiso = fecha_creacion_fideicomiso?.substring(0, 10) || "";
          this.compareciente.folio_inscripcion = folio_inscripcion;
          this.compareciente.rfc_fideicomiso = rfc_fideicomiso;
          this.compareciente.email_fideicomiso = email_fideicomiso;
          this.compareciente.tel_fideicomiso = tel_fideicomiso;
        }

        if (representantes != null) {
          for (let i2 = 0; i2 < representantes.length; i2++) {
            representantes[i2].representante =
              `${representantes[i2].nombre} ${representantes[i2].paterno} ${representantes[i2].materno}`;
            representantes[i2].fecha_nacimiento = representantes[i2].fecha_nacimiento?.substring(0, 10) || "";
            representantes[i2].instrumento_numero_fecha = representantes[i2].instrumento_numero_fecha?.substring(0, 10) || "";
            representantes[i2].instrumento_rpf_folio_fecha =
              representantes[i2].instrumento_rpf_folio_fecha?.substring(0, 10) || "";

            if (representantes[i2].mismo_constitutiva === 1) {
              representantes[i2].mismo_constitutiva = true;
            } else if (representantes[i2].mismo_constitutiva === 0) {
              representantes[i2].mismo_constitutiva = false;
            }

            if (representantes[i2].domicilios != null) {
              for (let i3 = 0; i3 < representantes[i2].domicilios.length; i3++) {
                if (representantes[i2].domicilios[i3].extranjero === 1) {
                  representantes[i2].domicilios[i3].extranjero = true;
                } else if (
                  representantes[i2].domicilios[i3].extranjero == 0 ||
                  representantes[i2].domicilios[i3].extranjero == null
                ) {
                  representantes[i2].domicilios[i3].extranjero = false;
                }
              }
            }

            if (representantes[i2].nacionalidades != null) {
              const nacionalidadesNamesRepresentantes = [];

              for (let i4 = 0; i4 < representantes[i2].nacionalidades.length; i4++) {
                const index = this.cat_nacionalidades.findIndex((o) => o.id === nacionalidades[i].nacionalidades_id);

                if (index !== -1) {
                  const nacionalidad = this.cat_nacionalidades[index];
                  nacionalidadesNamesRepresentantes.push(nacionalidad);
                }
              }

              representantes[i2].nacionalidades = nacionalidadesNamesRepresentantes;
            }

            if (representantes[i2].nacionalidad) {
              const nacionalidadesNamesRepresentantes = [];
              const _nacionnalidades = representantes[i2].nacionalidad.split(" ");

              for (const _nacionalidad of _nacionnalidades) {
                const index = this.cat_nacionalidades.findIndex((o) => o.nacionalidad === _nacionalidad);

                if (index !== -1) {
                  const nacionalidad = this.cat_nacionalidades[index];
                  nacionalidadesNamesRepresentantes.push(nacionalidad);
                }
              }

              representantes[i2].nacionalidades = nacionalidadesNamesRepresentantes;
            }

            const domicilios_originales = JSON.parse(JSON.stringify(representantes[i2].domicilios));
            representantes[i2].domicilios_originales = domicilios_originales;
            const telefonos_originales = JSON.parse(JSON.stringify(representantes[i2].telefonos));
            representantes[i2].telefonos_originales = telefonos_originales;
          }
        }

        this.representantes = representantes;
        this.representantes_originales = structuredClone(representantes);

        // console.log(documentos);
        //si es tipo otro, pones otro y topoOtro el vlauer guardado
        for (let r = 0; r < documentos.length; r++) {
          documentos[r].nombreFile = documentos[r].documento.split("/").pop();

          // let tipobd = documentos[r].tipo;
          // if (
          //   tipobd === "Identificación oficial" ||
          //   tipobd === "Comprobante de domicilio" ||
          //   tipobd === "RFC o Cédula de identificación Fiscal" ||
          //   tipobd === "CURP" ||
          //   tipobd === "Constitutiva" ||
          //   tipobd === "Poderes del representante" ||
          //   tipobd === "Cuadro de distribución accionaria"

          // ) {
          //   documentos[r].tipo = tipobd;
          // } else {
          //   documentos[r].tipo = "Otro";
          //   documentos[r].tipoOtro = tipobd;
          // }

          //donde pongo el tipo otro que es el campo descripcion?
          let tipo = null;

          if (persona === "Física") {
            if (actua_derecho_propio) {
              tipo = this.optionsFisicas.find((x) => x.value == documentos[r].cat_documentos_id);
            } else {
              tipo = this.optionsFisicasRepresentadas.find((x) => x.value == documentos[r].cat_documentos_id);
            }
          } else if (persona === "Moral") {
            tipo = this.optionsMorales.find((x) => x.value == documentos[r].cat_documentos_id);
          } else if (persona === "Fideicomiso") {
            tipo = this.optionsFideicomisos.find((x) => x.value == documentos[r].cat_documentos_id);
          }

          documentos[r].tipo = tipo?.text || "";
        }

        const documentosFiltrados = documentos.filter((d) => !d.documento.includes("kyc"));
        this.compareciente.documentos = documentosFiltrados;

        const documentos_originales = JSON.parse(JSON.stringify(this.compareciente.documentos));
        this.documentos_originales = documentos_originales;

        this.compareciente.documentos.forEach((d, i) => {
          d.index = i + 1;
        });

        const nacionalidadesNames = [];

        if (nacionalidades != null) {
          for (let i = 0; i < nacionalidades.length; i++) {
            const index = this.cat_nacionalidades.findIndex((o) => o.id === nacionalidades[i].nacionalidades_id);

            if (index !== -1) {
              const nacionalidad = this.cat_nacionalidades[index];

              nacionalidadesNames.push(nacionalidad);
            }
          }

          this.compareciente.nacionalidades = nacionalidadesNames;
        }

        // const original_user = JSON.parse(JSON.stringify(this.compareciente));
        // this.compareciente_original = original_user;
        this.compareciente_original = structuredClone(this.compareciente);

        this.compareciente.completado = completado;
        this.compareciente.cat_servicio_id = cat_servicio_id;
        this.compareciente.servicio_id = servicio_id;

        // Se deshabilitan los campos si el cliente ya guardo el formulario de ComplementaInformacion en Constitucion
        if (this.proceso === 1) {
          const { value } = await CatFormulariosConstitucionSociedadesApi.list({
            page: 0,
            registersPerPage: 0,
            constitucion_sociedades_id: servicio_id,
          });
          const formularioComplementaInformacion = value.find((f) => f.cat_formularios_id == 9);

          if (formularioComplementaInformacion?.guardado) {
            this.compareciente.disabled = true;
          }
        }
      } catch (error) {
        console.log(error);
        this.$toast.error("Error al cargar el compareciente", {
          timeout: 4000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      } finally {
        this.loading = false;
      }
    },

    async getCatNacionalidades() {
      const { value } = await CatNacionalidadesApi.list({
        page: 0,
        registersPerPage: 0,
      });
      this.cat_nacionalidades = value;
    },

    addDomicilio() {
      this.$refs["domicilio-modal"].show();

      this.currentDomicilio = {};
      this.currentDomicilio.tieneExtranjero = true;
      this.currentDomicilio.tieneTipo = true;
      this.currentDomicilio.compareciente = true;
      this.currentDomicilio.extranjero = false;
      this.currentDomicilio.lat = 19.4320605;
      this.currentDomicilio.lng = -99.1335938;
    },

    addTelefono() {
      this.$refs["telefono-modal"].show();
      this.currentTelefono = {};
    },

    addRepresentante() {
      this.$refs["representante-modal"].show();
      this.currentRepresentante = {
        domicilios: [],
        telefonos: [],
        instrumento_numero: null,
        instrumento_numero_fecha: null,
        instrumento_fedatario: null,
        instrumento_fedatario_nombre: null,
        instrumento_fedatario_numero: null,
        instrumento_fedatario_estado: null,
        instrumento_rpf_folio: null,
        instrumento_rpf_folio_fecha: null,
        instrumento_rpf_folio_lugar: null,
        personaARepresentar: this.compareciente.persona,
        alias: null,
        sexo: null,
      };
    },

    editRepresentante(representante) {
      this.$refs["representante-modal"].show();
      this.currentRepresentante = representante;
      this.current_representantes_id = representante.id;
      this.currentRepresentante.personaARepresentar = this.compareciente.persona;
    },

    editDomicilio(domicilio) {
      this.$refs["domicilio-modal"].show();
      this.currentDomicilio = domicilio;
    },

    editTelefono(telefono) {
      this.$refs["telefono-modal"].show();
      this.currentTelefono = telefono;
    },

    changePais() {
      if (this.currentDomicilio.pais === "México") {
        this.currentDomicilio.extranjero = false;
      } else if (this.currentDomicilio.pais != "México") {
        this.currentDomicilio.extranjero = true;
      }

      const a = Object.assign({}, this.currentDomicilio);
      this.currentDomicilio = a;
    },

    tipoDomicilio() {
      if (this.currentDomicilio.tipo != "Personal") {
        if (this.currentDomicilio.tipo === "Particular") {
          this.addDomicilioBtn = false;
        } else if (this.currentDomicilio.tipo === "Extranjero") {
          this.addDomicilioBtn = false;
        }
      }

      if (this.compareciente.domicilios.length >= 3) {
        this.addDomicilioBtn = false;
      }
    },

    postDomicilio() {
      this.currentDomicilio.tieneExtranjero = true;
      this.currentDomicilio.tieneTipo = true;

      if (
        this.currentDomicilio.tipo === "Extranjero" ||
        this.currentDomicilio.tipo === "Particular" ||
        this.currentDomicilio.tipo === "Fiscal"
      ) {
        this.addDomicilioBtn = true;
      } else if (this.currentDomicilio.tipo === "Particular y Fiscal") {
        this.addDomicilioBtn = false;
      }

      //ver si es post o put
      if (this.currentDomicilio.id === undefined) {
        this.currentDomicilio.id = this.compareciente.domicilios.length + 1;
        const a = Object.assign({}, this.currentDomicilio);
        this.compareciente.domicilios.push(a);
      } else if (this.currentDomicilio.id != undefined) {
        const index = this.compareciente.domicilios.findIndex((o) => o.id === this.currentDomicilio.id);
        const a = Object.assign({}, this.currentDomicilio);
        this.compareciente.domicilios.splice([index], 1, a);
      }

      this.$refs["domicilio-modal"].hide();
      this.currentDomicilio = {};

      if (this.compareciente.domicilios.length === 2) {
        let count = 0;
        for (let u = 0; u < this.compareciente.domicilios.length; u++) {
          if (this.compareciente.domicilios[u].tipo === "Particular") {
            count++;
          } else if (this.compareciente.domicilios[u].tipo === "Fiscal") {
            count++;
          }
        }
        if (count === 2) {
          this.addDomicilioBtn = false;
        }
      }
    },

    postTelefono() {
      if (!this.currentTelefono.id) {
        this.currentTelefono.id = this.compareciente.telefonos.length + 1;
        const a = Object.assign({}, this.currentTelefono);
        this.compareciente.telefonos.push(a);
      } else if (this.currentTelefono.id) {
        const index = this.compareciente.telefonos.findIndex((o) => o.id === this.currentTelefono.id);
        const a = Object.assign({}, this.currentTelefono);
        this.compareciente.telefonos.splice([index], 1, a);
      }

      this.$refs["telefono-modal"].hide();
    },

    postRepresentante() {
      if (this.currentRepresentante.id === undefined) {
        if (this.representantes != undefined) {
          this.currentRepresentante.id = this.representantes.length;
        } else {
          this.currentRepresentante.id = 0;
        }
        this.representantes.push(this.currentRepresentante);
      } else if (this.currentRepresentante.id != undefined) {
        const index = this.representantes.findIndex((o) => o.id === this.currentRepresentante.id);
        this.representantes[index] = this.currentRepresentante;
      }

      this.$refs["representante-modal"].hide();
    },

    predeleteDomicilio(id) {
      this.currentDomicilioId = id;
      this.$refs["modal-confirm-dialog-dom"].show();
    },

    deleteDomicilio() {
      let id = this.currentDomicilioId;

      const index = this.compareciente.domicilios.findIndex((o) => o.id == id);
      this.compareciente.domicilios.splice(index, 1);
      if (this.compareciente.domicilios.length > 1) {
        for (let i = 0; i < this.compareciente.domicilios.length; i++) {
          if (this.compareciente.domicilios[i].tipo != "Particular y Fiscal") {
            this.addDomicilioBtn = true;
          } else {
            this.addDomicilioBtn = false;
          }
        }
      } else {
        this.addDomicilioBtn = true;
      }
      this.$refs["modal-confirm-dialog-dom"].hide();
    },

    predeleteTelefono(id) {
      this.currentTelefonoId = id;
      this.$refs["modal-confirm-dialog-tel"].show();
    },

    deleteTelefono() {
      const id = this.currentTelefonoId;
      const index = this.compareciente.telefonos.findIndex((o) => o.id == id);
      this.compareciente.telefonos.splice(index, 1);
      this.$refs["modal-confirm-dialog-tel"].hide();
    },

    predeleteRepresentantes(id) {
      this.currentRepresentanteId = id;
      this.$refs["modal-confirm-dialog-repre"].show();
    },

    deleteRepresentante() {
      const id = this.currentRepresentanteId;
      const index = this.representantes.findIndex((o) => o.id == id);

      this.representantes.splice(index, 1);
      this.$refs["modal-confirm-dialog-repre"].hide();
    },

    async getClienteName(cliente_id) {
      const { nombre, paterno, materno, email } = await ClientesApi.detail(cliente_id);
      const datos_cliente = `${nombre} ${paterno} ${materno} ${email}`;
      return datos_cliente;
    },

    addDomicilioRepresentante() {
      this.$refs["domicilio-modal-representante"].show();
      this.currentDomicilio = {};
      this.currentDomicilio.tieneExtranjero = false;
      this.currentDomicilio.tieneTipo = false;
      this.currentDomicilio.tipo = "Personal";
      this.currentDomicilio.compareciente = false;
      this.currentDomicilio.lat = 19.4320605;
      this.currentDomicilio.lng = -99.1335938;
    },

    addTelefonoRepresentante() {
      // this.current_representantes_id = representantes_id;
      this.$refs["telefono-modal-representante"].show();
      this.currentTelefono = {};
    },

    editDomicilioRepresentante(domicilio) {
      this.$refs["domicilio-modal-representante"].show();
      this.currentDomicilio = domicilio;
    },

    editTelefonoRepresentante(telefono) {
      this.$refs["telefono-modal-representante"].show();
      this.currentTelefono = telefono;
    },

    postDomicilioRepresentante() {
      this.currentRepresentante.domicilios.tieneExtranjero = false;
      this.currentRepresentante.domicilios.tieneTipo = false;

      if (this.currentDomicilio.id === undefined) {
        this.currentDomicilio.id = this.currentRepresentante.domicilios.length + 1;
        const a = Object.assign({}, this.currentDomicilio);
        this.currentRepresentante.domicilios.push(a);
      } else if (this.currentDomicilio.id != undefined) {
        const index = this.currentRepresentante.domicilios.findIndex((o) => o.id === this.currentDomicilio.id);
        const a = Object.assign({}, this.currentDomicilio);
        // this.currentRepresentante.domicilios[index] = this.currentDomicilio;
        this.currentRepresentante.domicilios.splice([index], 1, a);
      }
      this.$refs["domicilio-modal-representante"].hide();
    },

    postTelefonoRepresentante() {
      // if (this.currentTelefono.id === undefined) {
      //   this.currentTelefono.id = this.currentRepresentante.telefonos.length;
      // }
      // this.currentRepresentante.telefonos.push(this.currentTelefono);
      //
      if (this.currentTelefono.id === undefined) {
        this.currentTelefono.id = this.currentRepresentante.telefonos.length;
        const a = Object.assign({}, this.currentTelefono);
        this.currentRepresentante.telefonos.push(a);
      } else if (this.currentTelefono.id != undefined) {
        const index = this.currentRepresentante.telefonos.findIndex((o) => o.id === this.currentTelefono.id);
        const a = Object.assign({}, this.currentTelefono);
        this.currentRepresentante.telefonos.splice([index], 1, a);
      }
      this.$refs["telefono-modal-representante"].hide();
    },

    predeleteDomicilioRepresentante(domicilio_id) {
      this.currentRepresentanteDomicilioId = domicilio_id;
      this.$refs["modal-confirm-dialog-repre-dom"].show();
    },

    deleteDomicilioRepresentante() {
      const domicilio_id = this.currentRepresentanteDomicilioId;
      // const index2 = this.representantes.findIndex(
      //   (o) => o.id == this.current_representantes_id
      // );
      // const index = this.representantes[index2].domicilios.findIndex(
      //   (o) => o.id == domicilio_id
      // );
      // this.representantes[index2].domicilios.splice(index, 1);
      const index = this.currentRepresentante.domicilios.findIndex((o) => o.id == domicilio_id);

      this.currentRepresentante.domicilios.splice(index, 1);
      this.$refs["modal-confirm-dialog-repre-dom"].hide();
    },

    predeleteTelefonoRepresentante(telefono_id) {
      this.currentRepresentanteTelefonoId = telefono_id;
      this.$refs["modal-confirm-dialog-repre-tel"].show();
    },

    deleteTelefonoRepresentante() {
      const telefono_id = this.currentRepresentanteTelefonoId;
      const index = this.currentRepresentante.telefonos.findIndex((o) => o.id == telefono_id);

      this.currentRepresentante.telefonos.splice(index, 1);
      this.$refs["modal-confirm-dialog-repre-tel"].hide();
    },

    mismaDataConstitutiva(state) {
      if (state === true) {
        this.currentRepresentante.instrumento_numero = this.compareciente.instrumento_numero;
        this.currentRepresentante.instrumento_numero_fecha = this.compareciente.instrumento_numero_fecha;
        this.currentRepresentante.instrumento_fedatario = this.compareciente.instrumento_fedatario;
        this.currentRepresentante.instrumento_fedatario_nombre = this.compareciente.instrumento_fedatario_nombre;
        this.currentRepresentante.instrumento_fedatario_numero = this.compareciente.instrumento_fedatario_numero;
        this.currentRepresentante.instrumento_fedatario_estado = this.compareciente.instrumento_fedatario_estado;
        this.currentRepresentante.instrumento_rpf_folio = this.compareciente.instrumento_rpf_folio;
        this.currentRepresentante.instrumento_rpf_folio_fecha = this.compareciente.instrumento_rpf_folio_fecha;
        this.currentRepresentante.instrumento_rpf_folio_lugar = this.compareciente.instrumento_rpf_folio_lugar;
      } else if (state === false) {
        this.currentRepresentante.instrumento_numero = null;
        this.currentRepresentante.instrumento_numero_fecha = null;
        this.currentRepresentante.instrumento_fedatario = null;
        this.currentRepresentante.instrumento_fedatario_nombre = null;
        this.currentRepresentante.instrumento_fedatario_numero = null;
        this.currentRepresentante.instrumento_fedatario_estado = null;
        this.currentRepresentante.instrumento_rpf_folio = null;
        this.currentRepresentante.instrumento_rpf_folio_fecha = null;
        this.currentRepresentante.instrumento_rpf_folio_lugar = null;
      }
    },

    addDocumento() {
      this.currentDocumento = {};
      this.$refs["documento-modal"].show();
    },

    async postDocumento() {
      this.$refs["documento-modal"].hide();
      this.loading = true;

      this.currentDocumento.tipo = this.currentDocumento.tipo.replace(" (Obligatorio)", "");

      await this.addFile();

      if (this.proceso === 2) {
        if (this.compareciente.persona === "Física" && !this.compareciente.actua_derecho_propio) {
          const index_s = this.optionsFisicasRepresentadas.findIndex((o) => o.text === this.currentDocumento.tipo);

          this.currentDocumento.cat_documentos_id = this.optionsFisicasRepresentadas[index_s].value;
        } else if (this.compareciente.persona === "Física") {
          const index_s = this.optionsFisicas.findIndex((o) => o.text === this.currentDocumento.tipo);
          this.currentDocumento.cat_documentos_id = this.optionsFisicas[index_s].value;
        } else if (this.compareciente.persona === "Moral") {
          const index_s = this.optionsMorales.findIndex((o) => o.text === this.currentDocumento.tipo);
          this.currentDocumento.cat_documentos_id = this.optionsMorales[index_s].value;
        }
      } else {
        if (this.compareciente.persona == "Física") {
          const index_s = this.optionsFisicas.findIndex((o) => o.text === this.currentDocumento.tipo);
          this.currentDocumento.cat_documentos_id = this.optionsFisicas[index_s].value;
        } else if (this.compareciente.persona == "Moral") {
          const index_s = this.optionsMorales.findIndex((o) => o.text === this.currentDocumento.tipo);
          this.currentDocumento.cat_documentos_id = this.optionsMorales[index_s].value;
        } else {
          const index_s = this.optionsFideicomisos.findIndex((o) => o.text === this.currentDocumento.tipo);
          this.currentDocumento.cat_documentos_id = this.optionsMorales[index_s].value;
        }
      }

      if (!this.currentDocumento.index) {
        const index = this.compareciente.documentos.length + 1;
        this.currentDocumento.index = index;
        const cloned = structuredClone(this.currentDocumento);

        this.compareciente.documentos.push(cloned);
      } else if (this.currentDocumento.index) {
        const index = this.compareciente.documentos.findIndex((o) => o.index === this.currentDocumento.index);
        const cloned = structuredClone(this.currentDocumento);

        this.compareciente.documentos.splice(index, 1, cloned);
      }

      this.loading = false;
    },

    async addFile() {
      try {
        const formData = new FormData();
        this.currentDocumento.nombreFile = this.currentDocumento.file.name;
        formData.append("file", this.currentDocumento.file);
        const value = await FuncionesApi.file(this.id, "documentosComparecientes", formData, {});
        this.currentDocumento.documento = value;
      } catch (error) {
        console.log(error);
      }
    },

    previewDocumento(item) {
      this.currentDocumento = item;

      let pretipoDocumento = item.nombreFile.split(".");
      let tipoDocumento = pretipoDocumento[pretipoDocumento.length - 1];

      if (tipoDocumento === "pdf") {
        this.$refs["documento-modal-preview-pdf"].show();
      }
      if (
        tipoDocumento === "jpg" ||
        tipoDocumento === "JPG" ||
        tipoDocumento === "jpeg" ||
        tipoDocumento === "png" ||
        tipoDocumento === "gif" ||
        tipoDocumento === "bmp" ||
        tipoDocumento === "webp" ||
        tipoDocumento === "svg" ||
        tipoDocumento === "tiff" ||
        tipoDocumento === "avif"
      ) {
        this.$refs["documento-modal-preview-img"].show();
      }
    },

    editDocumento(documento) {
      this.currentDocumento = documento;
      this.$refs["documento-modal"].show();
    },

    predeleteDocumento(id) {
      this.currentDocumentoId = id;
      this.$refs["modal-confirm-dialog-documento"].show();
    },

    async deleteDocumento() {
      const index2 = this.compareciente.documentos.findIndex((o) => o.index === this.currentDocumentoId);

      this.currentDocumento = this.compareciente.documentos[index2];

      await this.deleteFile();

      this.compareciente.documentos.splice(index2, 1);
      this.$refs["modal-confirm-dialog-documento"].hide();
    },

    async deleteFile(id) {
      try {
        this.loading = true;

        const data = {
          url: this.currentDocumento.documento,
          id: this.id,
        };

        await FuncionesApi.deleteFile("documentosComparecientes", data);
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async editCompareciente() {
      if (!this.tieneDocumentosRequeridos()) {
        this.$toast.error("Documentos incompletos.", {
          timeout: 4000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
        return;
      }
      if (!this.validaTelefonoCelularIngresado()) {
        return;
      }
      if (!this.compareciente.es_beneficiario && !this.compareciente.email) {
        this.$toast.warning("Por favor escriba su Email en la seccion Datos de contacto", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
        return;
      }

      this.loading = true;

      const nacionalidadesIds = [];

      if (this.compareciente.nacionalidades != null) {
        for (let i = 0; i < this.compareciente.nacionalidades.length; i++) {
          const index = this.cat_nacionalidades.findIndex(
            (o) => o.nacionalidad === this.compareciente.nacionalidades[i].nacionalidad,
          );

          if (index !== -1) {
            const nacionalidadId = this.cat_nacionalidades[index].id;
            const obj = { nacionalidades_id: nacionalidadId };
            nacionalidadesIds.push(obj);
          }
        }
      }

      const data = {
        cliente_id: this.compareciente.cliente_id,
        email: this.compareciente.email,
        rfc: this.compareciente.rfc,
        persona: this.compareciente.persona,
        activo: 1,
        // nacionalidad: this.compareciente.nacionalidad,
        facebook: this.compareciente.facebook,
        twitter: this.compareciente.twitter,
        instagram: this.compareciente.instagram,
        linkedin: this.compareciente.linkedin,
        nacionalidades: nacionalidadesIds,
        cat_servicio_id: this.compareciente.cat_servicio_id,
        servicio_id: this.compareciente.servicio_id,
        actua_derecho_propio: this.compareciente.actua_derecho_propio,
      };

      data["documentos"] = structuredClone(this.compareciente.documentos);

      if (this.compareciente.persona === "Física") {
        data["nombre"] = this.compareciente.nombre;
        data["paterno"] = this.compareciente.paterno;
        data["materno"] = this.compareciente.materno;
        data["fecha_nacimiento"] = this.compareciente.fecha_nacimiento;
        data["lugar_nacim_ciudad"] = this.compareciente.lugar_nacim_ciudad;
        data["lugar_nacim_estado"] = this.compareciente.lugar_nacim_estado;
        data["lugar_nacim_pais"] = this.compareciente.lugar_nacim_pais;
        data["curp"] = this.compareciente.curp;
        data["ocupacion"] = this.compareciente.ocupacion;
        data["giro_negocios"] = this.compareciente.giro_negocios;
        data["alias"] = this.compareciente.alias;
        data["sexo"] = this.compareciente.sexo;
        data["pais_residencia"] = this.compareciente.pais_residencia;
        data["estado_civil"] = this.compareciente.estado_civil;
        data["identificacion_conyuge"] = this.compareciente.identificacion_conyuge;
        data["regimen_patrimonial"] = this.compareciente.regimen_patrimonial;
        data["identificacion_numero"] = this.compareciente.identificacion_numero;

        data["estatus_migratorio"] = this.compareciente.estatus_migratorio;
        data["fecha_ingreso_pais"] = this.compareciente.fecha_ingreso_pais;

        if (this.compareciente.identificacion_tipo === "Otro") {
          data["identificacion_tipo"] = this.compareciente.identificacion_tipo_otro;
        } else {
          data["identificacion_tipo"] = this.compareciente.identificacion_tipo;
        }

        if (this.compareciente.identificacion_autoridad === "Otro") {
          data["identificacion_autoridad"] = this.compareciente.identificacion_autoridad_otro;
        } else {
          data["identificacion_autoridad"] = this.compareciente.identificacion_autoridad;
        }
      }
      if (this.compareciente.persona === "Moral") {
        data["denominacion_social"] = this.compareciente.denominacion_social;
        data["fecha_constitucion"] = this.compareciente.fecha_constitucion;
        data["actividad"] = this.compareciente.actividad;
        data["giro"] = this.compareciente.giro;
        data["objeto_social"] = this.compareciente.objeto_social;
        data["domicilio_social"] = this.compareciente.domicilio_social;
        data["instrumento_numero"] = this.compareciente.instrumento_numero;
        data["instrumento_numero_fecha"] = this.compareciente.instrumento_numero_fecha;
        data["instrumento_fedatario"] = this.compareciente.instrumento_fedatario;
        data["instrumento_fedatario_nombre"] = this.compareciente.instrumento_fedatario_nombre;
        data["instrumento_fedatario_numero"] = this.compareciente.instrumento_fedatario_numero;
        data["instrumento_fedatario_estado"] = this.compareciente.instrumento_fedatario_estado;
        data["instrumento_rpf_folio"] = this.compareciente.instrumento_rpf_folio;
        data["instrumento_rpf_folio_fecha"] = this.compareciente.instrumento_rpf_folio_fecha;
        data["instrumento_rpf_folio_lugar"] = this.compareciente.instrumento_rpf_folio_lugar;

        if (this.compareciente.entidad_extranjera === true || this.compareciente.entidad_extranjera === 1) {
          data["entidad_extranjera"] = 1;
        } else if (this.compareciente.entidad_extranjera === false || this.compareciente.entidad_extranjera === 0) {
          data["entidad_extranjera"] = 0;
        }

        data["datos_prueba_constitucion"] = this.compareciente.datos_prueba_constitucion;
      }

      if (this.compareciente.persona === "Fideicomiso") {
        data["denominacion_social"] = this.compareciente.denominacion_social;
        data["fecha_constitucion"] = this.compareciente.fecha_constitucion;
        data["actividad"] = this.compareciente.actividad;
        data["giro"] = this.compareciente.giro;
        data["objeto_social"] = this.compareciente.objeto_social;
        data["instrumento_numero"] = this.compareciente.instrumento_numero;
        data["instrumento_numero_fecha"] = this.compareciente.instrumento_numero_fecha;
        data["instrumento_fedatario"] = this.compareciente.instrumento_fedatario;
        data["instrumento_fedatario_numero"] = this.compareciente.instrumento_fedatario_numero;
        data["instrumento_fedatario_estado"] = this.compareciente.instrumento_fedatario_estado;
        data["instrumento_rpf_folio"] = this.compareciente.instrumento_rpf_folio;
        data["instrumento_rpf_folio_fecha"] = this.compareciente.instrumento_rpf_folio_fecha;
        data["instrumento_rpf_folio_lugar"] = this.compareciente.instrumento_rpf_folio_lugar;

        if (this.compareciente.entidad_extranjera === true || this.compareciente.entidad_extranjera === 1) {
          data["entidad_extranjera"] = 1;
        } else if (this.compareciente.entidad_extranjera === false || this.compareciente.entidad_extranjera === 0) {
          data["entidad_extranjera"] = 0;
        }

        data["datos_prueba_constitucion"] = this.compareciente.datos_prueba_constitucion;
        data["fiduciario"] = this.compareciente.fiduciario;
        data["nombre_fideicomiso"] = this.compareciente.nombre_fideicomiso;
        data["fideicomitente"] = this.compareciente.fideicomitente;
        // data["tipo_fideicomiso"] = this.compareciente.tipo_fideicomiso;
        if (this.compareciente.identificacion_tipo === "Otro") {
          data["tipo_fideicomiso"] = this.compareciente.tipo_fideicomiso;
        } else {
          data["tipo_fideicomiso"] = this.compareciente.tipo_fideicomiso;
        }

        data["fecha_creacion_fideicomiso"] = this.compareciente.fecha_creacion_fideicomiso;
        data["folio_inscripcion"] = this.compareciente.folio_inscripcion;
        data["rfc_fideicomiso"] = this.compareciente.rfc_fideicomiso;
        data["email_fideicomiso"] = this.compareciente.email_fideicomiso;
        data["tel_fideicomiso"] = this.compareciente.tel_fideicomiso;
      }

      if (this.compareciente.domicilios != null) {
        for (let i = 0; i < this.compareciente.domicilios.length; i++) {
          if (this.compareciente.domicilios[i].extranjero === true || this.compareciente.domicilios[i].extranjero === 1) {
            this.compareciente.domicilios[i].extranjero = 1;
          } else if (this.compareciente.domicilios[i].extranjero === false || this.compareciente.domicilios[i].extranjero === 0) {
            this.compareciente.domicilios[i].extranjero = 0;
          }
        }
      }
      data["domicilios"] = this.compareciente.domicilios;
      data["telefonos"] = this.compareciente.telefonos;

      for (let i = 0; i < this.representantes.length; i++) {
        data.actua_derecho_propio = false;

        if (this.representantes[i].mismo_constitutiva === true || this.representantes[i].mismo_constitutiva === 1) {
          this.representantes[i].mismo_constitutiva = 1;
        } else if (this.representantes[i].mismo_constitutiva === false || this.representantes[i].mismo_constitutiva === 0) {
          this.representantes[i].mismo_constitutiva = 0;
        }

        if (this.representantes[i].domicilios != null) {
          for (let k = 0; k < this.representantes[i].domicilios.length; k++) {
            if (this.representantes[i].domicilios[k].extranjero) {
              this.representantes[i].domicilios[k].extranjero = 1;
            } else {
              this.representantes[i].domicilios[k].extranjero = 0;
            }
          }
        }

        const nacionalidadesRepresentantesIds = [];
        let nacionalidadesNames = "";

        if (this.representantes[i].nacionalidades != null) {
          for (let l = 0; l < this.representantes[i].nacionalidades.length; l++) {
            const index = this.cat_nacionalidades.findIndex(
              (o) => o.nacionalidad === this.representantes[i].nacionalidades[l].nacionalidad,
            );

            if (index !== -1) {
              const nacionalidadId = this.cat_nacionalidades[index].id;
              nacionalidadesRepresentantesIds.push({ nacionalidades_id: nacionalidadId });
            }

            nacionalidadesNames += `${this.representantes[i].nacionalidades[l].nacionalidad} `;
          }
        }

        this.representantes[i].nacionalidades = nacionalidadesRepresentantesIds;
        this.representantes[i].nacionalidad = nacionalidadesNames.trim();
      }

      data["representantes"] = this.representantes;

      let tipo_validacion = "";
      //de constitutivas
      const query = this.$route.query;
      const accion = query.accion;

      if (accion === "nuevo" || accion === "edit" || accion === "valid") {
        if (this.compareciente.persona === "Física") {
          tipo_validacion = "constitucion_pf";
        } else if (this.compareciente.persona === "Moral") {
          tipo_validacion = "constitucion_pm";
        }
      }

      if (accion == "newFormalizacion") {
        tipo_validacion = "new_formalizacion";
      }

      if (accion == "validFormalizacion") {
        tipo_validacion = "formalizacion_pf"; //solo hay pf delegados
      }

      if (accion == "editRatificacion") {
        if (this.compareciente.persona === "Física") {
          tipo_validacion = "ratificacion_pf";
        } else if (this.compareciente.persona === "Moral") {
          tipo_validacion = "ratificacion_pm";
        }
      }

      if (this.proceso === 2) {
        if (this.compareciente.persona === "Física") {
          tipo_validacion = "notificacion_pf";
        } else if (this.compareciente.persona === "Moral") {
          tipo_validacion = "notificacion_pm";
        }
      }

      if (accion == "editcotejo" || accion == "validcotejo") {
        // tipo_validacion = "cotejo_representante";
        if (this.compareciente.persona === "Física") {
          tipo_validacion = "notificacion_pf";
        } else if (this.compareciente.persona === "Moral") {
          tipo_validacion = "notificacion_pm";
        }
      }

      if (!accion) {
        if (this.compareciente.persona === "Física") {
          tipo_validacion = "individual_pf";
          if (this.ratificacion) {
            tipo_validacion = "ratificacion_pf";
          }
        } else if (this.compareciente.persona === "Moral") {
          tipo_validacion = "individual_pm";
          if (this.ratificacion) {
            tipo_validacion = "ratificacion_pm";
          }
        } else if (this.compareciente.persona === "Fideicomiso") {
          tipo_validacion = "individual_fid";
        }
      }

      data["tipo_validacion"] = tipo_validacion;

      try {
        await ComparecientesApi.edit(this.comparecienteId, data);

        const query = Object.assign({}, this.$route.query);

        if (query) {
          let procesoAccion = query.procesoAccion;
          let procesoId = query.procesoId;

          //solo para staff
          if (procesoAccion === "validconstitucion") {
            this.setCambios();
            //post en cambios
            for (let r = 0; r < this.cambios.length; r++) {
              await CambiosConstitutivaApi.create({
                constitucion_sociedades_id: procesoId,
                formulario: this.cambios[r].formulario,
                campo: this.cambios[r].campo,
                valor_original: this.cambios[r].valor_original,
                valor_cambio: this.cambios[r].valor_cambio,
              });
            }
          }

          this.$toast.success("Compareciente actualizado", {
            timeout: 4000, //false,
            hideProgressBar: false,
            position: "top-right",
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            closeButton: "button",
            icon: true,
          });

          let accion = query.accion;
          if (accion === "nuevo") {
            this.$router.push({
              path: `/dashboard/procesos/editconstitucion/${procesoId}`,
              query: {
                node: "Accionistas",
              },
            });
          } else if (accion === "edit") {
            let node = "Accionistas";
            if (this.compareciente.es_beneficiario) {
              node = "BeneficiarioControlador";
            }
            this.$router.push({
              path: `/dashboard/clienttasks/editconstitucion/${procesoId}`,
              query: {
                node: node,
              },
            });
          } else if (accion === "valid") {
            this.$router.push({
              path: `/dashboard/tasks/valid/constitucion/${procesoId}`,
              query: {
                node: "Accionistas",
              },
            });
          } else if (accion === "newFormalizacion") {
            this.$router.push({
              path: `/dashboard/clienttasks/editformalizacion/${procesoId}`,
              query: {
                node: "ComplementaInformacion",
              },
            });
          }
          // else if (accion === "editFormalizacion") {
          //   this.$router.push({
          //     path: `/dashboard/tasks/procesos/formalizacion/${procesoId}`,
          //     query: {
          //       node: "ComplementaInformacion"
          //     }
          //   });
          // }
          else if (accion === "validFormalizacion") {
            this.$router.push({
              path: `/dashboard/tasks/valid/formalizacion/${procesoId}`,
              query: {
                node: "ComplementaInformacion",
              },
            });
          } else if (accion === "editRatificacion") {
            this.$router.push({
              path: `/dashboard/clienttasks/editratificacion/${procesoId}`,
              query: {
                node: "ComplementaInformacion",
              },
            });
          } else if (accion === "editnotificacion") {
            this.$router.push({
              path: `/dashboard/clienttasks/editnotificacion/${procesoId}`,
              query: {
                node: "ComplementaInformacion",
              },
            });
          } else if (accion === "validnotificacion") {
            this.$router.push({
              path: `/dashboard/tasks/valid/notificacion/${procesoId}`,
              query: {
                node: "ComplementaInformacion",
              },
            });
          } else if (accion === "editcotejo") {
            this.$router.push({
              path: `/dashboard/clienttasks/editcotejo/${procesoId}`,
              query: {
                node: "Solicitantes",
              },
            });
          }
          else if (accion === "validcotejo") {
            this.$router.push({
              name: "ValidCotejo",
              params: {
                id: this.procesoId
              },
              query: {
                node: "Solicitantes"
              }
            });
          }
        }
      } catch (error) {
        console.log(error);
        this.$toast.error("Sucedió un error, intente más tarde", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      } finally {
        this.loading = false;
      }
    },

    setCambios() {
      if (this.compareciente.persona === "Física" || this.compareciente.persona === "Moral") {
        if (this.compareciente.persona === "Física") {
          if (this.compareciente.estatus_migratorio != this.compareciente_original.estatus_migratorio) {
            this.cambios.push({
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_estatus_migratorio`,
              valor_original: this.compareciente_original.estatus_migratorio,
              valor_cambio: this.compareciente.estatus_migratorio,
            });
            this.compareciente_original.estatus_migratorio = this.compareciente.estatus_migratorio;
          }
          if (this.compareciente.nombre != this.compareciente_original.nombre) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_nombre`,
              valor_original: this.compareciente_original.nombre,
              valor_cambio: this.compareciente.nombre,
            };
            this.cambios.push(obj);
            this.compareciente_original.nombre = this.compareciente.nombre;
          }
          if (this.compareciente.paterno != this.compareciente_original.paterno) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_paterno`,
              valor_original: this.compareciente_original.paterno,
              valor_cambio: this.compareciente.paterno,
            };
            this.cambios.push(obj);
            this.compareciente_original.paterno = this.compareciente.paterno;
          }
          if (this.compareciente.materno != this.compareciente_original.materno) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_materno`,
              valor_original: this.compareciente_original.materno,
              valor_cambio: this.compareciente.materno,
            };
            this.cambios.push(obj);
            this.compareciente_original.materno = this.compareciente.materno;
          }

          if (this.compareciente.identificacion_tipo != this.compareciente_original.identificacion_tipo) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_identificacion_tipo`,
              valor_original: this.compareciente_original.identificacion_tipo,
              valor_cambio: this.compareciente.identificacion_tipo,
            };
            this.cambios.push(obj);
            this.compareciente_original.identificacion_tipo = this.compareciente.identificacion_tipo;
          }
          if (this.compareciente.identificacion_autoridad != this.compareciente_original.identificacion_autoridad) {
            const obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_identificacion_autoridad`,
              valor_original: this.compareciente_original.identificacion_autoridad,
              valor_cambio: this.compareciente.identificacion_autoridad,
            };
            this.cambios.push(obj);
            this.compareciente_original.identificacion_autoridad = this.compareciente.identificacion_autoridad;
          }
          if (this.compareciente.identificacion_numero != this.compareciente_original.identificacion_numero) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_identificacion_numero`,
              valor_original: this.compareciente_original.identificacion_numero,
              valor_cambio: this.compareciente.identificacion_numero,
            };
            this.cambios.push(obj);
            this.compareciente_original.identificacion_numero = this.compareciente.identificacion_numero;
          }

          if (this.compareciente.rfc != this.compareciente_original.rfc) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_rfc`,
              valor_original: this.compareciente_original.rfc,
              valor_cambio: this.compareciente.rfc,
            };
            this.cambios.push(obj);
            this.compareciente_original.rfc = this.compareciente.rfc;
          }
          if (this.compareciente.curp != this.compareciente_original.curp) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_curp`,
              valor_original: this.compareciente_original.curp,
              valor_cambio: this.compareciente.curp,
            };
            this.cambios.push(obj);
            this.compareciente_original.curp = this.compareciente.curp;
          }

          if (this.compareciente.fecha_nacimiento != this.compareciente_original.fecha_nacimiento) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_fecha_nacimiento`,
              valor_original: this.compareciente_original.fecha_nacimiento,
              valor_cambio: this.compareciente.fecha_nacimiento,
            };
            this.cambios.push(obj);
            this.compareciente_original.fecha_nacimiento = this.compareciente.fecha_nacimiento;
          }
          try {
            for (let i = 0; i < this.compareciente.nacionalidades.length; i++) {
              if (
                this.compareciente.nacionalidades[i].nacionalidad != this.compareciente_original.nacionalidades[i].nacionalidad
              ) {
                const obj = {
                  formulario: "Comparecientes",
                  campo: `compareciente_id_${this.id}_nacionalidades_${i}`,
                  valor_original: this.compareciente_original.nacionalidades[i].nacionalidad,
                  valor_cambio: this.compareciente.nacionalidades[i].nacionalidad,
                };
                this.cambios.push(obj);
                this.compareciente_original.nacionalidades[i].nacionalidad = this.compareciente.nacionalidades[i].nacionalidad;
              }
            }
          } catch (e) {
            console.log(e);
          }
          if (this.compareciente.sexo != this.compareciente_original.sexo) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_sexo`,
              valor_original: this.compareciente_original.sexo,
              valor_cambio: this.compareciente.sexo,
            };
            this.cambios.push(obj);
            this.compareciente_original.sexo = this.compareciente.sexo;
          }

          if (this.compareciente.lugar_nacim_ciudad != this.compareciente_original.lugar_nacim_ciudad) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_lugar_nacim_ciudad`,
              valor_original: this.compareciente_original.lugar_nacim_ciudad,
              valor_cambio: this.compareciente.lugar_nacim_ciudad,
            };
            this.cambios.push(obj);
            this.compareciente_original.lugar_nacim_ciudad = this.compareciente.lugar_nacim_ciudad;
          }
          if (this.compareciente.lugar_nacim_estado != this.compareciente_original.lugar_nacim_estado) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_lugar_nacim_estado`,
              valor_original: this.compareciente_original.lugar_nacim_estado,
              valor_cambio: this.compareciente.lugar_nacim_estado,
            };
            this.cambios.push(obj);
            this.compareciente_original.lugar_nacim_estado = this.compareciente.lugar_nacim_estado;
          }
          if (this.compareciente.lugar_nacim_pais != this.compareciente_original.lugar_nacim_pais) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_lugar_nacim_pais`,
              valor_original: this.compareciente_original.lugar_nacim_pais,
              valor_cambio: this.compareciente.lugar_nacim_pais,
            };
            this.cambios.push(obj);
            this.compareciente_original.lugar_nacim_pais = this.compareciente.lugar_nacim_pais;
          }

          if (this.compareciente.ocupacion != this.compareciente_original.ocupacion) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_ocupacion`,
              valor_original: this.compareciente_original.ocupacion,
              valor_cambio: this.compareciente.ocupacion,
            };
            this.cambios.push(obj);
            this.compareciente_original.ocupacion = this.compareciente.ocupacion;
          }
          if (this.compareciente.giro_negocios != this.compareciente_original.giro_negocios) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_giro_negocios`,
              valor_original: this.compareciente_original.giro_negocios,
              valor_cambio: this.compareciente.giro_negocios,
            };
            this.cambios.push(obj);
            this.compareciente_original.giro_negocios = this.compareciente.giro_negocios;
          }
          if (this.compareciente.estado_civil != this.compareciente_original.estado_civil) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_estado_civil`,
              valor_original: this.compareciente_original.estado_civil,
              valor_cambio: this.compareciente.estado_civil,
            };
            this.cambios.push(obj);
            this.compareciente_original.estado_civil = this.compareciente.estado_civil;
          }

          if (this.compareciente.alias != this.compareciente_original.alias) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_alias`,
              valor_original: this.compareciente_original.alias,
              valor_cambio: this.compareciente.alias,
            };
            this.cambios.push(obj);
            this.compareciente_original.alias = this.compareciente.alias;
          }
          if (this.compareciente.identificacion_conyuge != this.compareciente_original.identificacion_conyuge) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_identificacion_conyuge`,
              valor_original: this.compareciente_original.identificacion_conyuge,
              valor_cambio: this.compareciente.identificacion_conyuge,
            };
            this.cambios.push(obj);
            this.compareciente_original.identificacion_conyuge = this.compareciente.identificacion_conyuge;
          }
          if (this.compareciente.regimen_patrimonial != this.compareciente_original.regimen_patrimonial) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_regimen_patrimonial`,
              valor_original: this.compareciente_original.regimen_patrimonial,
              valor_cambio: this.compareciente.regimen_patrimonial,
            };
            this.cambios.push(obj);
            this.compareciente_original.regimen_patrimonial = this.compareciente.regimen_patrimonial;
          }

          if (this.compareciente.email != this.compareciente_original.email) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_email`,
              valor_original: this.compareciente_original.email,
              valor_cambio: this.compareciente.email,
            };
            this.cambios.push(obj);
            this.compareciente_original.email = this.compareciente.email;
          }
          if (this.compareciente.facebook != this.compareciente_original.facebook) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_facebook`,
              valor_original: this.compareciente_original.facebook,
              valor_cambio: this.compareciente.facebook,
            };
            this.cambios.push(obj);
            this.compareciente_original.facebook = this.compareciente.facebook;
          }
          if (this.compareciente.twitter != this.compareciente_original.twitter) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_twitter`,
              valor_original: this.compareciente_original.twitter,
              valor_cambio: this.compareciente.twitter,
            };
            this.cambios.push(obj);
            this.compareciente_original.twitter = this.compareciente.twitter;
          }
          if (this.compareciente.instagram != this.compareciente_original.instagram) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_instagram`,
              valor_original: this.compareciente_original.instagram,
              valor_cambio: this.compareciente.instagram,
            };
            this.cambios.push(obj);
            this.compareciente_original.instagram = this.compareciente.instagram;
          }
          if (this.compareciente.linkedin != this.compareciente_original.linkedin) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_linkedin`,
              valor_original: this.compareciente_original.linkedin,
              valor_cambio: this.compareciente.linkedin,
            };
            this.cambios.push(obj);
            this.compareciente_original.linkedin = this.compareciente.linkedin;
          }
        } else if (this.compareciente.persona === "Moral") {
          if (this.compareciente.denominacion_social != this.compareciente_original.denominacion_social) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_denominacion_social`,
              valor_original: this.compareciente_original.denominacion_social,
              valor_cambio: this.compareciente.denominacion_social,
            };
            this.cambios.push(obj);
            this.compareciente_original.denominacion_social = this.compareciente.denominacion_social;
          }

          if (this.compareciente.actividad != this.compareciente_original.actividad) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_actividad`,
              valor_original: this.compareciente_original.actividad,
              valor_cambio: this.compareciente.actividad,
            };
            this.cambios.push(obj);
            this.compareciente_original.actividad = this.compareciente.actividad;
          }
          if (this.compareciente.fecha_constitucion != this.compareciente_original.fecha_constitucion) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_fecha_constitucion`,
              valor_original: this.compareciente_original.fecha_constitucion,
              valor_cambio: this.compareciente.fecha_constitucion,
            };
            this.cambios.push(obj);
            this.compareciente_original.fecha_constitucion = this.compareciente.fecha_constitucion;
          }
          try {
            for (let i = 0; i < this.compareciente.nacionalidades.length; i++) {
              if (this.compareciente.nacionalidades[i] != this.compareciente_original.nacionalidades[i]) {
                let obj = {
                  formulario: "Comparecientes",
                  campo: `compareciente_id_${this.id}_nacionalidades_${i}`,
                  valor_original: this.compareciente_original.nacionalidades[i],
                  valor_cambio: this.compareciente.nacionalidades[i],
                };
                this.cambios.push(obj);
                this.compareciente_original.nacionalidades[i] = this.compareciente.nacionalidades[i];
              }
            }
          } catch (e) {
            // console.log(e);
          }

          if (this.compareciente.objeto_social != this.compareciente_original.objeto_social) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_objeto_social`,
              valor_original: this.compareciente_original.objeto_social,
              valor_cambio: this.compareciente.objeto_social,
            };
            this.cambios.push(obj);
            this.compareciente_original.objeto_social = this.compareciente.objeto_social;
          }

          if (this.compareciente.instrumento_numero != this.compareciente_original.instrumento_numero) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_instrumento_numero`,
              valor_original: this.compareciente_original.instrumento_numero,
              valor_cambio: this.compareciente.instrumento_numero,
            };
            this.cambios.push(obj);
            this.compareciente_original.instrumento_numero = this.compareciente.instrumento_numero;
          }
          if (this.compareciente.instrumento_numero_fecha != this.compareciente_original.instrumento_numero_fecha) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_instrumento_numero_fecha`,
              valor_original: this.compareciente_original.instrumento_numero_fecha,
              valor_cambio: this.compareciente.instrumento_numero_fecha,
            };
            this.cambios.push(obj);
            this.compareciente_original.instrumento_numero_fecha = this.compareciente.instrumento_numero_fecha;
          }

          if (this.compareciente.instrumento_fedatario != this.compareciente_original.instrumento_fedatario) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_instrumento_fedatario`,
              valor_original: this.compareciente_original.instrumento_fedatario,
              valor_cambio: this.compareciente.instrumento_fedatario,
            };
            this.cambios.push(obj);
            this.compareciente_original.instrumento_fedatario = this.compareciente.instrumento_fedatario;
          }
          if (this.compareciente.instrumento_fedatario_nombre != this.compareciente_original.instrumento_fedatario_nombre) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_instrumento_fedatario_nombre`,
              valor_original: this.compareciente_original.instrumento_fedatario_nombre,
              valor_cambio: this.compareciente.instrumento_fedatario_nombre,
            };
            this.cambios.push(obj);
            this.compareciente_original.instrumento_fedatario_nombre = this.compareciente.instrumento_fedatario_nombre;
          }
          if (this.compareciente.instrumento_fedatario_numero != this.compareciente_original.instrumento_fedatario_numero) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_instrumento_fedatario_numero`,
              valor_original: this.compareciente_original.instrumento_fedatario_numero,
              valor_cambio: this.compareciente.instrumento_fedatario_numero,
            };
            this.cambios.push(obj);
            this.compareciente_original.instrumento_fedatario_numero = this.compareciente.instrumento_fedatario_numero;
          }
          if (this.compareciente.instrumento_fedatario_estado != this.compareciente_original.instrumento_fedatario_estado) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_instrumento_fedatario_estado`,
              valor_original: this.compareciente_original.instrumento_fedatario_estado,
              valor_cambio: this.compareciente.instrumento_fedatario_estado,
            };
            this.cambios.push(obj);
            this.compareciente_original.instrumento_fedatario_estado = this.compareciente.instrumento_fedatario_estado;
          }

          if (this.compareciente.instrumento_rpf_folio != this.compareciente_original.instrumento_rpf_folio) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_instrumento_rpf_folio`,
              valor_original: this.compareciente_original.instrumento_rpf_folio,
              valor_cambio: this.compareciente.instrumento_rpf_folio,
            };
            this.cambios.push(obj);
            this.compareciente_original.instrumento_rpf_folio = this.compareciente.instrumento_rpf_folio;
          }
          if (this.compareciente.instrumento_rpf_folio_fecha != this.compareciente_original.instrumento_rpf_folio_fecha) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_instrumento_rpf_folio_fecha`,
              valor_original: this.compareciente_original.instrumento_rpf_folio_fecha,
              valor_cambio: this.compareciente.instrumento_rpf_folio_fecha,
            };
            this.cambios.push(obj);
            this.compareciente_original.instrumento_rpf_folio_fecha = this.compareciente.instrumento_rpf_folio_fecha;
          }
          if (this.compareciente.instrumento_rpf_folio_lugar != this.compareciente_original.instrumento_rpf_folio_lugar) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_instrumento_rpf_folio_lugar`,
              valor_original: this.compareciente_original.instrumento_rpf_folio_lugar,
              valor_cambio: this.compareciente.instrumento_rpf_folio_lugar,
            };
            this.cambios.push(obj);
            this.compareciente_original.instrumento_rpf_folio_lugar = this.compareciente.instrumento_rpf_folio_lugar;
          }

          if (this.compareciente.entidad_extranjera != this.compareciente_original.entidad_extranjera) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_entidad_extranjera`,
              valor_original: this.compareciente_original.entidad_extranjera,
              valor_cambio: this.compareciente.entidad_extranjera,
            };
            this.cambios.push(obj);
            this.compareciente_original.entidad_extranjera = this.compareciente.entidad_extranjera;
          }

          if (this.compareciente.rfc != this.compareciente_original.rfc) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_rfc`,
              valor_original: this.compareciente_original.rfc,
              valor_cambio: this.compareciente.rfc,
            };
            this.cambios.push(obj);
            this.compareciente_original.rfc = this.compareciente.rfc;
          }
          if (this.compareciente.email != this.compareciente_original.email) {
            let obj = {
              formulario: "Compareciente",
              campo: `compareciente_id_${this.id}_email`,
              valor_original: this.compareciente_original.email,
              valor_cambio: this.compareciente.email,
            };
            this.cambios.push(obj);
            this.compareciente_original.email = this.compareciente.email;
          }
        }

        try {
          for (let i = 0; i < this.compareciente.domicilios.length; i++) {
            const objKeys = Object.keys(this.compareciente.domicilios[i]);
            objKeys.forEach((key) => {
              if (this.compareciente.domicilios[i][key] != this.domicilios_originales[i][key]) {
                let obj = {
                  formulario: "Compareciente",
                  campo: `compareciente_id_${this.id}_domicilios_${i}_${[key]}`,
                  valor_original: this.domicilios_originales[i][key],
                  valor_cambio: this.compareciente.domicilios[i][key],
                };
                this.cambios.push(obj);
                this.domicilios_originales[i][key] = this.compareciente.domicilios[i][key];
              }
            });
          }
        } catch (e) {
          // console.log(e);
        }

        try {
          for (let i = 0; i < this.compareciente.telefonos.length; i++) {
            const objKeys = Object.keys(this.compareciente.telefonos[i]);
            objKeys.forEach((key) => {
              if (this.compareciente.telefonos[i][key] != this.telefonos_originales[i][key]) {
                let obj = {
                  formulario: "Compareciente",
                  campo: `compareciente_id_${this.id}_telefono_${i}_${[key]}`,
                  valor_original: this.telefonos_originales[i][key],
                  valor_cambio: this.compareciente.telefonos[i][key],
                };
                this.cambios.push(obj);
                this.telefonos_originales[i][key] = this.compareciente.telefonos[i][key];
              }
            });
          }
        } catch (e) {
          // console.log(e);
        }

        try {
          for (let i = 0; i < this.compareciente.documentos.length; i++) {
            if (this.compareciente.documentos[i].tipo != this.documentos_originales[i].tipo) {
              let obj = {
                formulario: "Compareciente",
                campo: `compareciente_id_${this.id}_documentos_${i}_tipo`,
                valor_original: this.documentos_originales[i].tipo,
                valor_cambio: this.compareciente.documentos[i].tipo,
              };
              this.cambios.push(obj);
              this.documentos_originales[i].tipo = this.compareciente.documentos[i].tipo;
            }

            if (this.compareciente.documentos[i].documento != this.documentos_originales[i].documento) {
              let obj = {
                formulario: "Compareciente",
                campo: `compareciente_id_${this.id}_documentos_${i}_documento`,
                valor_original: this.documentos_originales[i].documento,
                valor_cambio: this.compareciente.documentos[i].documento,
              };
              this.cambios.push(obj);
              this.documentos_originales[i].documento = this.compareciente.documentos[i].documento;
            }
          }
        } catch (e) {
          // console.log(e);
        }

        if (this.representantes_originales.length > 0) {
          for (let i = 0; i < this.representantes.length; i++) {
            if (this.representantes[i].nombre != this.representantes_originales[i].nombre) {
              let obj = {
                formulario: "Compareciente",
                campo: `compareciente_id_${this.id}_representante_${i}_nombre`,
                valor_original: this.representantes[i].nombre,
                valor_cambio: this.representantes_originales[i].nombre,
              };
              this.cambios.push(obj);
              this.representantes_originales[i].nombre = this.representantes[i].nombre;
            }
            if (this.representantes[i].paterno != this.representantes_originales[i].paterno) {
              let obj = {
                formulario: "Compareciente",
                campo: `compareciente_id_${this.id}_representante_${i}_paterno`,
                valor_original: this.representantes[i].paterno,
                valor_cambio: this.representantes_originales[i].paterno,
              };
              this.cambios.push(obj);
              this.representantes_originales[i].paterno = this.representantes[i].paterno;
            }
            if (this.representantes[i].materno != this.representantes_originales[i].materno) {
              let obj = {
                formulario: "Compareciente",
                campo: `compareciente_id_${this.id}_representante_${i}_materno`,
                valor_original: this.representantes[i].materno,
                valor_cambio: this.representantes_originales[i].materno,
              };
              this.cambios.push(obj);
              this.representantes_originales[i].materno = this.representantes[i].materno;
            }

            if (this.representantes[i].rfc != this.representantes_originales[i].rfc) {
              let obj = {
                formulario: "Compareciente",
                campo: `compareciente_id_${this.id}_representante_${i}_rfc`,
                valor_original: this.representantes[i].rfc,
                valor_cambio: this.representantes_originales[i].rfc,
              };
              this.cambios.push(obj);
              this.representantes_originales[i].rfc = this.representantes[i].rfc;
            }
            if (this.representantes[i].curp != this.representantes_originales[i].curp) {
              let obj = {
                formulario: "Compareciente",
                campo: `compareciente_id_${this.id}_representante_${i}_curp`,
                valor_original: this.representantes[i].curp,
                valor_cambio: this.representantes_originales[i].curp,
              };
              this.cambios.push(obj);
              this.representantes_originales[i].curp = this.representantes[i].curp;
            }
            if (this.representantes[i].email != this.representantes_originales[i].email) {
              let obj = {
                formulario: "Compareciente",
                campo: `compareciente_id_${this.id}_representante_${i}_email`,
                valor_original: this.representantes[i].email,
                valor_cambio: this.representantes_originales[i].email,
              };
              this.cambios.push(obj);
              this.representantes_originales[i].email = this.representantes[i].email;
            }

            if (this.representantes[i].fecha_nacimiento != this.representantes_originales[i].fecha_nacimiento) {
              let obj = {
                formulario: "Compareciente",
                campo: `compareciente_id_${this.id}_representante_${i}_fecha_nacimiento`,
                valor_original: this.representantes[i].fecha_nacimiento,
                valor_cambio: this.representantes_originales[i].fecha_nacimiento,
              };
              this.cambios.push(obj);
              this.representantes_originales[i].fecha_nacimiento = this.representantes[i].fecha_nacimiento;
            }
            if (this.representantes[i].nacionalidad != this.representantes_originales[i].nacionalidad) {
              let obj = {
                formulario: "Compareciente",
                campo: `compareciente_id_${this.id}_representante_${i}_nacionalidad`,
                valor_original: this.representantes[i].nacionalidad,
                valor_cambio: this.representantes_originales[i].nacionalidad,
              };
              this.cambios.push(obj);
              this.representantes_originales[i].nacionalidad = this.representantes[i].nacionalidad;
            }

            if (this.representantes[i].lugar_nacim_ciudad != this.representantes_originales[i].lugar_nacim_ciudad) {
              let obj = {
                formulario: "Compareciente",
                campo: `compareciente_id_${this.id}_representante_${i}_lugar_nacim_ciudad`,
                valor_original: this.representantes[i].lugar_nacim_ciudad,
                valor_cambio: this.representantes_originales[i].lugar_nacim_ciudad,
              };
              this.cambios.push(obj);
              this.representantes_originales[i].lugar_nacim_ciudad = this.representantes[i].lugar_nacim_ciudad;
            }
            if (this.representantes[i].lugar_nacim_estado != this.representantes_originales[i].lugar_nacim_estado) {
              let obj = {
                formulario: "Compareciente",
                campo: `compareciente_id_${this.id}_representante_${i}_lugar_nacim_estado`,
                valor_original: this.representantes[i].lugar_nacim_estado,
                valor_cambio: this.representantes_originales[i].lugar_nacim_estado,
              };
              this.cambios.push(obj);
              this.representantes_originales[i].lugar_nacim_estado = this.representantes[i].lugar_nacim_estado;
            }
            if (this.representantes[i].lugar_nacim_pais != this.representantes_originales[i].lugar_nacim_pais) {
              let obj = {
                formulario: "Compareciente",
                campo: `compareciente_id_${this.id}_representante_${i}_lugar_nacim_pais`,
                valor_original: this.representantes[i].lugar_nacim_pais,
                valor_cambio: this.representantes_originales[i].lugar_nacim_pais,
              };
              this.cambios.push(obj);
              this.representantes_originales[i].lugar_nacim_pais = this.representantes[i].lugar_nacim_pais;
            }

            if (this.representantes[i].identificacion_tipo != this.representantes_originales[i].identificacion_tipo) {
              let obj = {
                formulario: "Compareciente",
                campo: `compareciente_id_${this.id}_representante_${i}_identificacion_tipo`,
                valor_original: this.representantes[i].identificacion_tipo,
                valor_cambio: this.representantes_originales[i].identificacion_tipo,
              };
              this.cambios.push(obj);
              this.representantes_originales[i].identificacion_tipo = this.representantes[i].identificacion_tipo;
            }
            if (this.representantes[i].identificacion_autoridad != this.representantes_originales[i].identificacion_autoridad) {
              let obj = {
                formulario: "Compareciente",
                campo: `compareciente_id_${this.id}_representante_${i}_identificacion_autoridad`,
                valor_original: this.representantes[i].identificacion_autoridad,
                valor_cambio: this.representantes_originales[i].identificacion_autoridad,
              };
              this.cambios.push(obj);
              this.representantes_originales[i].identificacion_autoridad = this.representantes[i].identificacion_autoridad;
            }
            if (this.representantes[i].identificacion_numero != this.representantes_originales[i].identificacion_numero) {
              let obj = {
                formulario: "Compareciente",
                campo: `compareciente_id_${this.id}_representante_${i}_identificacion_numero`,
                valor_original: this.representantes[i].identificacion_numero,
                valor_cambio: this.representantes_originales[i].identificacion_numero,
              };
              this.cambios.push(obj);
              this.representantes_originales[i].identificacion_numero = this.representantes[i].identificacion_numero;
            }

            if (this.representantes[i].instrumento_numero != this.representantes_originales[i].instrumento_numero) {
              let obj = {
                formulario: "Compareciente",
                campo: `compareciente_id_${this.id}_representante_${i}_instrumento_numero`,
                valor_original: this.representantes[i].instrumento_numero,
                valor_cambio: this.representantes_originales[i].instrumento_numero,
              };
              this.cambios.push(obj);
              this.representantes_originales[i].instrumento_numero = this.representantes[i].instrumento_numero;
            }
            if (this.representantes[i].instrumento_numero_fecha != this.representantes_originales[i].instrumento_numero_fecha) {
              let obj = {
                formulario: "Compareciente",
                campo: `compareciente_id_${this.id}_representante_${i}_instrumento_numero_fecha`,
                valor_original: this.representantes[i].instrumento_numero_fecha,
                valor_cambio: this.representantes_originales[i].instrumento_numero_fecha,
              };
              this.cambios.push(obj);
              this.representantes_originales[i].instrumento_numero_fecha = this.representantes[i].instrumento_numero_fecha;
            }

            if (this.representantes[i].instrumento_fedatario != this.representantes_originales[i].instrumento_fedatario) {
              let obj = {
                formulario: "Compareciente",
                campo: `compareciente_id_${this.id}_representante_${i}_instrumento_fedatario`,
                valor_original: this.representantes[i].instrumento_fedatario,
                valor_cambio: this.representantes_originales[i].instrumento_fedatario,
              };
              this.cambios.push(obj);
              this.representantes_originales[i].instrumento_fedatario = this.representantes[i].instrumento_fedatario;
            }
            if (
              this.representantes[i].instrumento_fedatario_nombre !=
              this.representantes_originales[i].instrumento_fedatario_nombre
            ) {
              let obj = {
                formulario: "Compareciente",
                campo: `compareciente_id_${this.id}_representante_${i}_instrumento_fedatario_nombre`,
                valor_original: this.representantes[i].instrumento_fedatario_nombre,
                valor_cambio: this.representantes_originales[i].instrumento_fedatario_nombre,
              };
              this.cambios.push(obj);
              this.representantes_originales[i].instrumento_fedatario_nombre =
                this.representantes[i].instrumento_fedatario_nombre;
            }
            if (
              this.representantes[i].instrumento_fedatario_numero !=
              this.representantes_originales[i].instrumento_fedatario_numero
            ) {
              let obj = {
                formulario: "Compareciente",
                campo: `compareciente_id_${this.id}_representante_${i}_instrumento_fedatario_numero`,
                valor_original: this.representantes[i].instrumento_fedatario_numero,
                valor_cambio: this.representantes_originales[i].instrumento_fedatario_numero,
              };
              this.cambios.push(obj);
              this.representantes_originales[i].instrumento_fedatario_numero =
                this.representantes[i].instrumento_fedatario_numero;
            }
            if (
              this.representantes[i].instrumento_fedatario_estado !=
              this.representantes_originales[i].instrumento_fedatario_estado
            ) {
              let obj = {
                formulario: "Compareciente",
                campo: `compareciente_id_${this.id}_representante_${i}_instrumento_fedatario_estado`,
                valor_original: this.representantes[i].instrumento_fedatario_estado,
                valor_cambio: this.representantes_originales[i].instrumento_fedatario_estado,
              };
              this.cambios.push(obj);
              this.representantes_originales[i].instrumento_fedatario_estado =
                this.representantes[i].instrumento_fedatario_estado;
            }

            if (this.representantes[i].instrumento_rpf_folio != this.representantes_originales[i].instrumento_rpf_folio) {
              let obj = {
                formulario: "Compareciente",
                campo: `compareciente_id_${this.id}_representante_${i}_instrumento_rpf_folio`,
                valor_original: this.representantes[i].instrumento_rpf_folio,
                valor_cambio: this.representantes_originales[i].instrumento_rpf_folio,
              };
              this.cambios.push(obj);
              this.representantes_originales[i].instrumento_rpf_folio = this.representantes[i].instrumento_rpf_folio;
            }
            if (
              this.representantes[i].instrumento_rpf_folio_fecha != this.representantes_originales[i].instrumento_rpf_folio_fecha
            ) {
              let obj = {
                formulario: "Compareciente",
                campo: `compareciente_id_${this.id}_representante_${i}_instrumento_rpf_folio_fecha`,
                valor_original: this.representantes[i].instrumento_rpf_folio_fecha,
                valor_cambio: this.representantes_originales[i].instrumento_rpf_folio_fecha,
              };
              this.cambios.push(obj);
              this.representantes_originales[i].instrumento_rpf_folio_fecha = this.representantes[i].instrumento_rpf_folio_fecha;
            }
            if (
              this.representantes[i].instrumento_rpf_folio_lugar != this.representantes_originales[i].instrumento_rpf_folio_lugar
            ) {
              let obj = {
                formulario: "Compareciente",
                campo: `compareciente_id_${this.id}_representante_${i}_instrumento_rpf_folio_lugar`,
                valor_original: this.representantes[i].instrumento_rpf_folio_lugar,
                valor_cambio: this.representantes_originales[i].instrumento_rpf_folio_lugar,
              };
              this.cambios.push(obj);
              this.representantes_originales[i].instrumento_rpf_folio_lugar = this.representantes[i].instrumento_rpf_folio_lugar;
            }

            try {
              for (let j = 0; j < this.representantes[i].domicilios.length; j++) {
                const objKeys = Object.keys(this.representantes[i].domicilios[j]);
                objKeys.forEach((key) => {
                  if (this.representantes[i].domicilios[j][key] != this.representantes[i].domicilios_originales[j][key]) {
                    const obj = {
                      formulario: "Compareciente",
                      campo: `compareciente_id_${this.id}_representante_${i}_domicilio_${j}_${[key]}`,
                      valor_original: this.representantes[i].domicilios_originales[j][key],
                      valor_cambio: this.representantes[i].domicilios[j][key],
                    };
                    this.cambios.push(obj);
                    this.representantes[i].domicilios_originales[j][key] = this.representantes[i].domicilios[j][key];
                  }
                });
              }
            } catch (e) {
              // console.log(e);
            }

            try {
              for (let j = 0; j < this.representantes[i].telefonos.length; j++) {
                const objKeys = Object.keys(this.representantes[i].telefonos[j]);
                objKeys.forEach((key) => {
                  if (this.representantes[i].telefonos[j][key] != this.representantes[i].telefonos_originales[j][key]) {
                    const obj = {
                      formulario: "Compareciente",
                      campo: `compareciente_id_${this.id}_representante_${i}_telefono_${j}_${[key]}`,
                      valor_original: this.representantes[i].telefonos_originales[j][key],
                      valor_cambio: this.representantes[i].telefonos[j][key],
                    };
                    this.cambios.push(obj);
                    this.representantes[i].telefonos_originales[j][key] = this.representantes[i].telefonos[j][key];
                  }
                });
              }
            } catch (e) {
              // console.log(e);
            }
          }
        }
      }
    },

    tieneDocumentosRequeridos() {
      if (this.proceso === 4) return true;

      const documentos = this.compareciente.documentos;

      if (documentos.length === 0) {
        console.log("sin documentos");
        return false;
      }

      if (this.compareciente.persona === "Física" && !this.compareciente.actua_derecho_propio) {
        let flag = true;
        this.optionsFisicasRepresentadas.forEach((d) => {
          if (d.obligatorio) {
            if (documentos.findIndex((x) => Number(x.cat_documentos_id) === d.value) === -1) {
              flag = false;
            }
          }
        });

        if (!flag) {
          console.log("documento obligatorio faltante");
          return false;
        }

        return true;
      }

      if (this.compareciente.persona === "Física" && this.compareciente.actua_derecho_propio) {
        let flag = true;
        this.optionsFisicas.forEach((d) => {
          if (d.obligatorio) {
            if (documentos.findIndex((x) => Number(x.cat_documentos_id) === d.value) === -1) {
              flag = false;
            }
          }
        });

        if (!flag) {
          console.log("documento obligatorio faltante");
          return false;
        }

        return true;
      }

      if (this.compareciente.persona === "Moral") {
        let flag = true;
        this.optionsMorales.forEach((d) => {
          if (d.obligatorio) {
            if (documentos.findIndex((x) => Number(x.cat_documentos_id) === d.value) === -1) {
              flag = false;
            }
          }
        });

        if (!flag) {
          console.log("documento obligatorio faltante");
          return false;
        }

        return true;
      }

      return true;
    },

    validaTelefonoCelularIngresado() {
      if (this.compareciente.es_beneficiario) {
        return true;
      }

      let celularRegistrado = false;
      let mensaje = "Al menos un representante debe registrar un numero de teléfono celular para el proceso de FAD.";

      if (this.compareciente.actua_derecho_propio) {
        celularRegistrado = this.compareciente.telefonos.some((t) => t.tipo === "Celular");
        mensaje = "Debe registrar al menos un numero de teléfono celular para el proceso de FAD.";
      } else {
        for (const r of this.representantes) {
          if (r.telefonos.some((t) => t.tipo === "Celular")) {
            celularRegistrado = true;
            break;
          }
        }
      }

      if (!celularRegistrado) {
        this.$toast.warning(mensaje, {
          timeout: 6000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });

        return false;
      }

      return true;
    },

    regresarHandler() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.bottomLeft {
  position: fixed;
  left: 15%;
  bottom: 5%;
  overflow: visible;
  z-index: 100;
}
</style>
